/* ==========================================================================
   Homegym-Berater — Version 1, Artboard A «Gefuehrt»
   --------------------------------------------------------------------------
   Geladen von: sections/ceq-home-gym-configurator.liquid (nur dort).
   Vorlage:     Canvas A, Branch docs/home-gym-konfigurator,
                docs/design/home-gym-konfigurator/Main.dc.html (Stand 18.09.2026).
   Regeln:      crossequip-marketing/themen/gym-planung/
                2026-09-17-self-service-konfigurator-einordnung.md — bei Widerspruch gilt sie.

   Datenquellen (alles live aus der Section, das JS kennt nur SKUs):
   - Katalog-JSON: Preis, Verfuegbarkeit, Bild je SKU. Nicht lagernde Artikel werden NICHT
     angeboten (Entscheid Simon 21.09.2026) — ein «verfuegbar ab»-Datum gibt es im Shop nicht.
   - Specs-JSON: Metafeld custom.specs je Produkt, in der Shop-Sprache. Jede Produktgruppe zeigt
     dieselben Eigenschaften in derselben Reihenfolge (SPEC_ALIASES), unabhaengig davon, wie das
     einzelne Produkt sie beschriftet.

   Bewusste Abweichungen vom Canvas:
   - Befestigung als eine Frage mit vier Faellen (Wand / nur Boden / keine / weiss nicht) statt
     Wand-Frage plus Verschiebbar-Schalter (Simon 21.09.). Wand = Beton oder massives Mauerwerk.
   - Jede Produktgruppe hat eine «Keine …»-Option, immer als letzte Kachel.
   - Storage ist bepreist: ein Regal = 2 Pfosten + Ablagen (Odoo-Stueckliste STORAGE-SET-DB-03-S /
     -MU-01-L), bis 3 Ebenen tiefe, 4 Ebenen hohe Pfosten; mehr = Anfrage. Ablagebreite 106 cm
     aus storage-rechner/data/shelves.yaml (das Canvas rechnete 60/70 cm).
   - Rack-Vorauswahl ueberspringt Racks, die nicht passen oder nicht lagernd sind.
   - Hip Thrust Bench als Extra nur bei Trainingsweg B — bei A ist sie Teil der Bank-Auswahl.

   Texte: ausschliesslich aus dem i18n-JSON der Section. Einzige Ausnahme ist der Uebergabetext fuer
   den Verkauf (salesSummary) — der ist bewusst immer Deutsch.
   ========================================================================== */
(function () {
  'use strict';
  if (customElements.get('ceq-home-gym-configurator')) return;

  const TOOL_VERSION = 'v1-canvas-a.9';
  const PAYLOAD_SCHEMA = 'ceq-homegym-berater/1';
  const SHELF_CM = 106;
  const PHOTO_MAX_PX = 2000;
  const PHOTO_INPUT_MAX = 25 * 1024 * 1024;
  const SEND_TIMEOUT_MS = 30000;
  // Botschutz wie beim HomeGym Lead Capture (crossequip-knowledge/formular-botschutz.md): Honeypot + Timetrap.
  // Gemessen ab dem Oeffnen des Formulars, nicht ab dem Seitenaufruf -- davor liegen hier fuenf Schritte.
  const MIN_FILL_MS = 2000;

  /* ---------- Eigenschaften: Label-Varianten der Produkte (DE + EN aus custom.specs) ---------- */
  const SPEC_ALIASES = {
    breite: ['Breite', 'Width', 'Breite (Standfüsse)', 'Width (base)'],
    tiefe: ['Tiefe', 'Depth'],
    hoehe: ['Höhe', 'Height'],
    laenge: ['Länge', 'Length', 'Gesamtlänge', 'Total length'],
    gewicht: ['Gewicht', 'Weight'],
    griff: ['Griffdurchmesser', 'Grip diameter', 'Durchmesser Griffbereich', 'Shaft diameter'],
    dicke: ['Gesamtdicke', 'Total thickness', 'Dicke', 'Thickness'],
    format: ['Formate', 'Formats', 'Masse', 'Size'],
    durchmesser: ['Durchmesser', 'Diameter', 'Aussendurchmesser', 'Outer diameter'],
    material: ['Material'],
    kopf: ['Material Kopf', 'Head material', 'Kopf', 'Head'],
    kugel: ['Kugeldurchmesser', 'Bell diameter', 'Ball diameter'],
    waende: ['Geeignete Wände', 'Suitable walls'],
    abmessungen: ['Abmessungen', 'Dimensions'],
    hoehen: ['Trainingshöhen', 'Training Heights', 'Höhen', 'Heights'],
    loop: ['Loop-Länge', 'Loop length'],
    strap: ['Strap-Länge', 'Strap length'],
  };
  const SPEC_LABEL = { kopf: 'material' };

  /* ---------- Bausteine -> SKUs (Preise und Masse NICHT hier, die kommen live) ---------- */
  // format = was der Konfigurator bestellt: immer 1-m²-Platten (Menge = ceil(Flaeche x Faktor)). Das Metafeld nennt
  // beim PRO CONNECT auch 50 x 50 cm -- das kann man hier nicht waehlen, darum steht es nicht in der Kachel.
  const FLOORS = [
    { id: 'pro25', skus: { blk: 'HG-PRO-25-TIL-CON-BLK-1', gry: 'HG-PRO-25-TIL-CON-BLK-GRY-1' }, thick: 2.5, facts: 2, format: '1 × 1 m', slots: ['dicke', 'format'] },
    { id: 'core15', skus: { blk: 'HG-COR-15-PZL-BLK-1' }, thick: 1.5, facts: 4, format: '1 × 1 m', slots: ['dicke', 'format'] },
    // Ersatz fuer den Puzzle: erscheint nur, wenn es den Puzzle in der gewaehlten Farbe nicht lagernd gibt (Entscheid Simon 21.09.).
    { id: 'core15t', fallbackFor: 'core15', skus: { blk: 'HG-COR-15-TIL-BLK-1', gry: 'HG-COR-15-TIL-BLK-GRY-1' }, thick: 1.5, facts: 4, format: '1 × 1 m', slots: ['dicke', 'format'] },
  ];
  // fp/h = Rueckfall, falls custom.specs fehlt. Gemessen am Metafeld 21.09.2026.
  const RACKS = [
    { id: 'cwr1', sku: 'CWR-1-220-60', fp: [121, 68], h: 220, needsWall: true, facts: 3 },
    { id: 'cpr150', sku: 'CPR-150', fp: [121, 121], h: 220, facts: 3 },
    { id: 'apex', sku: 'AL-APEX', fp: [200, 160], h: 221, facts: 3 },
    { id: 'sqst', fp: [121, 121], facts: 3,
      variants: [{ sku: 'AL-SQST-180-S', h: 180 }, { sku: 'AL-SQST-220-S', h: 220 }, { sku: 'AL-SQST-240-S', h: 240 }] },
    { id: 'cpr100', sku: 'CPR-100', fp: [121, 75], h: 220, needsAnchor: true, facts: 3 },
  ];
  const RACK_ORDER = { wall: ['cwr1', 'cpr150', 'sqst'], floor: ['cpr150', 'sqst'], none: ['sqst'], unknown: ['cpr150', 'sqst'] };
  const BARS = [
    { id: 'bb20', sku: 'BB-20', len: 220, facts: 2 },
    { id: 'bbh15', sku: 'BB-H15', len: 183, facts: 3 },
    { id: 'bb15', sku: 'BB-15', len: 201, facts: 2 },
  ];
  // 70 kg = 2 x 5, 10, 20 als Einzelscheiben. 150 kg Color = bestehendes Shop-Set,
  // 150 kg Black gibt es nicht als Set -> Einzelscheiben (keine erfundenen Setpreise).
  const PLATES = [
    { id: 'p70', facts: 2, items: {
      color: [['HG-CBP-05', 2], ['HG-CBP-10', 2], ['HG-CBP-20', 2]],
      black: [['HG-BBP-05', 2], ['HG-BBP-10', 2], ['HG-BBP-20', 2]] } },
    { id: 'p150', facts: 2, items: {
      color: [['HG-CBP-SET', 1]],
      black: [['HG-BBP-05', 2], ['HG-BBP-10', 2], ['HG-BBP-15', 2], ['HG-BBP-20', 2], ['HG-BBP-25', 2]] } },
  ];
  const CP_SKU = 'HG-CP-SET-S';
  const BENCHES = [
    { id: 'flat', sku: 'HG-FBNCH', facts: 2 },
    { id: 'hip', sku: 'HITHRBNCH-L', facts: 2 },
    { id: 'adj', sku: 'HG-ADJBNCH', facts: 2 },
  ];
  const HEX = [
    { id: 'start', key: 'hex_start', items: [['HXDB-5', 2], ['HXDB-10', 2], ['HXDB-15', 2], ['HXDB-20', 2]], width: 113 },
    { id: 'big', key: 'hex_big', items: [['HXDB-SET-025-30', 1]], width: 364 },
  ];
  // Ablagebreiten aus storage-rechner/data/footprints.yaml (PCKB je kg, COKB konstant 21 cm).
  const KB_LINES = {
    pckb: { start: [['PCKB-08', 1], ['PCKB-12', 1], ['PCKB-16', 1]],
      big: [['PCKB-08', 1], ['PCKB-12', 1], ['PCKB-16', 1], ['PCKB-20', 1], ['PCKB-24', 1], ['PCKB-28', 1], ['PCKB-32', 1]],
      wStart: 53.5, wBig: 133.5, slots: ['kugel', 'material'] },
    cokb: { start: [['COKB-08', 1], ['COKB-12', 1], ['COKB-16', 1]], big: [['COKB-SET-B', 1]], wStart: 63, wBig: 147, slots: ['kugel', 'material'] },
  };
  const KB = [{ id: 'start', key: 'kb_start' }, { id: 'big', key: 'kb_big' }];
  const PULLUPS = [
    { id: 'wpus', key: 'wpus', sku: 'WPUS', needsWall: true, slots: ['breite', 'tiefe', 'waende'] },
    { id: 'sqstpu', key: 'sqstpu', sku: 'AL-SQST-220', fp: [121, 121], h: 220, slots: ['breite', 'tiefe', 'hoehe'] },
  ];
  const EXTRAS = [
    { id: 'plywod', sku: 'SFTPLY-WOD', alt: 'plyas', slots: ['abmessungen', 'hoehen'] },
    { id: 'plyas', sku: 'ASPLYO', alt: 'plywod', slots: ['hoehen'] },
    { id: 'wb6', sku: 'WB-06', alt: 'wb9', slots: ['durchmesser'] },
    { id: 'wb9', sku: 'WB-09', alt: 'wb6', slots: ['durchmesser'] },
    { id: 'jr', sku: 'HS-EA-JR', slots: [] },
    { id: 'rb', sku: 'RB-SET', slots: ['loop'] },
    { id: 'rings', sku: 'WDGYR', needsHang: true, slots: ['strap'] },
    { id: 'hipx', sku: 'HITHRBNCH-L', onlyB: true, slots: ['laenge', 'hoehe'] },
  ];
  const STORAGE = { db: 'STORAGE-CR-DB-S', kb: 'STORAGE-CR-KB-S', upS: 'STORAGE-UP-S', upL: 'STORAGE-UP-L' };
  const FIX_OPTS = ['wall', 'floor', 'none', 'unknown'];
  const CHANGE_LABEL = { floor: 'zone_floor', colour: 'colour', rack: 'zone_rack', bar: 'zone_bar', plates: 'plates', line: 'plates',
    bench: 'zone_bench', hex: 'zone_hex', kbLine: 'zone_kb', kb: 'zone_kb', pullup: 'zone_pullup', extras: 'zone_extras', storage: 'zone_storage' };

  /* ---------- Hilfen ---------- */
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const num = (v, f) => { const x = Number(v); return isFinite(x) && x > 0 ? x : f; };
  const cmOf = (s) => { const m = String(s || '').match(/(\d+(?:[.,]\d+)?)\s*cm/); return m ? Number(m[1].replace(',', '.')) : null; };
  function chf(x) {
    const r = Math.round(x * 100) / 100;
    const int = Math.floor(Math.abs(r));
    const frac = Math.round((Math.abs(r) - int) * 100);
    return (r < 0 ? '-' : '') + int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'") + (frac ? '.' + (frac < 10 ? '0' : '') + frac : '');
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => { const r = (Math.random() * 16) | 0; return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16); });
  }
  /* GA4: direkt ueber gtag, bewusst OHNE send_to -- wie ceq-turf-track.js und ceq-web-vitals.liquid.
     GA4 (G-J16LSHP8Y8) haengt am Google-&-YouTube-App-Pixel; im GTM-Container liegt kein GA4-Tag, ein
     reiner dataLayer-Push kaeme nie an (gemessen an generate_lead, wiki/tracking-stack-messluecken.md).
     Ohne send_to geht jedes Ereignis auch an Google Ads -- darum nur fuenf Zeitpunkte:
     hgc_start, hgc_step (3 und 5), hgc_consult_open, hgc_cart_add, generate_lead -- dazu hgc_consult_fail
     (selten, nur wenn der Versand scheitert).
     Die hgc_*-Parameter und lead_source sind in GA4 als eigene Dimensionen angelegt. */
  const gaQueue = [];
  function flushGa(tries) {
    if (typeof window.gtag === 'function') { gaQueue.splice(0).forEach(([n, p]) => window.gtag('event', n, p)); return; }
    if (tries < 20) { setTimeout(() => flushGa(tries + 1), 500); return; }
    // gtag kam nicht (Blocker, Pixel aus): wie die anderen Module in den dataLayer, falls GTM einmal ein GA4-Tag bekommt.
    window.dataLayer = window.dataLayer || [];
    gaQueue.splice(0).forEach(([n, p]) => window.dataLayer.push(Object.assign({ event: n }, p)));
  }
  function track(name, params) {
    gaQueue.push([name, params || {}]);
    if (gaQueue.length === 1) flushGa(0);
  }
  const AVATAR_SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 12h2M18 12h2M7 8v8M17 8v8M9 10v4M15 10v4M9 12h6"></path></svg>';

  /* ---------- Raumregeln ---------- */
  function roomFacts(room) {
    const Lc = num(room.l, 0), Wc = num(room.w, 0);
    const rectArea = Lc * Wc / 10000;
    const area = room.shape === 'angled' ? Math.min(num(room.area, rectArea), rectArea) : rectArea;
    const H = room.hUnknown ? null : num(room.h, 0);
    return { L: Lc, W: Wc, H, area, rectArea, maxSide: Math.max(Lc, Wc), factor: room.shape === 'angled' ? 1.10 : 1.05 };
  }
  function usableHeight(room, facts, floorThick) {
    if (facts.H === null) return null;
    return room.hMeasured === 'after' ? facts.H : Math.round((facts.H - floorThick) * 10) / 10;
  }
  // Passform pro Produkt. Unter 15 cm Rest = knapp (Arbeitsannahme des Canvas, keine Produktregel).
  function fitLevel(usable, productH) {
    if (usable === null) return { level: 'unknown' };
    if (productH === null || productH === undefined) return { level: 'check' };
    const rest = Math.round((usable - productH) * 10) / 10;
    if (rest < 0) return { level: 'no', rest };
    if (rest < 15) return { level: 'tight', rest };
    return { level: 'ok', rest };
  }
  function sqstVariant(usable) {
    const vs = RACKS.find((r) => r.id === 'sqst').variants;
    if (usable === null) return vs[1];
    const ok = vs.filter((v) => usable - v.h >= 15);
    return ok.length ? ok[ok.length - 1] : vs[0];
  }

  /* ---------- Custom Element ---------- */
  class HomeGymConfigurator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.t = JSON.parse(this.querySelector('[data-hgc-i18n]').textContent);
        this.cat = JSON.parse(this.querySelector('[data-hgc-catalog]').textContent);
        this.specs = JSON.parse(this.querySelector('[data-hgc-specs]').textContent);
      } catch (e) {
        console.error('[ceq-hgc] JSON der Section nicht lesbar', e);
        return;
      }
      delete this.cat._end; delete this.specs._end;
      this.lang = this.dataset.lang === 'en' ? 'en' : 'de';
      this.testMode = this.dataset.testMode === 'true';
      this.webhook = (this.dataset.webhook || '').trim();
      this.phone = this.dataset.phone || '';
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.narrow = window.matchMedia('(max-width: 989px)');
      this.source = this.readSource();
      this.s = {
        step: 1, training: null,
        room: { l: 400, w: 300, h: 250, hUnknown: false, hMeasured: 'before', shape: 'rect', area: 12, fix: 'unknown', use: null, neigh: null },
        sel: null, touched: {}, roomTouched: {}, openZones: {}, replaced: null, info: null,
        consultOpen: false, chan: 'mail', montage: false,
        form: { first: '', last: '', email: '', phone: '', question: '', hp: '' },
        errors: {}, photos: { room: null, access: null }, photoError: {},
        cart: { state: 'idle' }, send: { state: 'idle' },
        configId: uuid(), prevConfigId: null, formOpenedAt: null, cartSig: null, cartConfigId: null, started: false, seenProposal: false, seenResult: false, cartAddedAt: null, cartPositions: 0,
      };
      this.els = { steps: this.querySelector('[data-hgc-steps]'), main: this.querySelector('[data-hgc-main]') };
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('keydown', (e) => this.onKey(e));
      this.addEventListener('input', (e) => this.onInput(e));
      this.addEventListener('change', (e) => this.onChange(e));
      this.mobile.addEventListener('change', () => this.render());
      this.narrow.addEventListener('change', () => this.render());
      const missing = this.requiredSkus().filter((s) => !this.cat[s]);
      if (missing.length) console.warn('[ceq-hgc] SKUs fehlen im Katalog der Section:', missing.join(', '));
      this.render();
    }

    /* ----- Texte ----- */
    tr(key, vars) {
      let s = this.t[key];
      if (s === undefined) { console.warn('[ceq-hgc] Text fehlt:', key); return key; }
      if (vars) s = s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m));
      return s;
    }
    plural(key, n, vars) { return this.tr(key + (n === 1 ? '_one' : '_other'), Object.assign({ n }, vars || {})); }
    fmt1(x) { const s = (Math.round(x * 10) / 10).toString(); return this.lang === 'de' ? s.replace('.', ',') : s; }
    fmt3(x) { const s = (Math.round(x * 1000) / 1000).toString(); return this.lang === 'de' ? s.replace('.', ',') : s; }
    pName(id) { return this.tr('p_' + id + '_name'); }
    pOpt(id, field) { const k = 'p_' + id + '_' + field; return this.t[k] !== undefined ? this.t[k] : ''; }
    pFacts(id, n) { const out = []; for (let i = 1; i <= n; i++) out.push(this.tr('p_' + id + '_f' + i)); return out; }

    /* ----- Katalog ----- */
    v(sku) { return this.cat[sku] || null; }
    itemsPrice(items) {
      let sum = 0;
      for (const [sku, qty] of items) { const v = this.v(sku); if (!v) return null; sum += (v.price / 100) * qty; }
      return sum;
    }
    // listed = steht mit Preis im Katalog und wird gezeigt. offered = zusaetzlich lagernd: nur das wird empfohlen und vorausgewaehlt.
    // Nicht Lagerndes ist waehlbar, traegt ein Badge und geht nur per Anfrage (Entscheid Simon 21.09.).
    listed(items) { return items.length > 0 && items.every(([sku]) => !!this.v(sku)); }
    offered(items) { return items.length > 0 && items.every(([sku]) => { const v = this.v(sku); return v && v.available; }); }
    img(sku) { const v = this.v(sku); return v && v.image ? v.image : null; }
    specItems(sku) { const v = this.v(sku); return (v && this.specs[v.handle]) || []; }
    specVal(sku, slot) {
      const names = SPEC_ALIASES[slot] || [];
      const it = this.specItems(sku).find((x) => names.indexOf(String(x.label).trim()) !== -1);
      return it ? String(it.value) : null;
    }
    specRows(sku, slots, overrides) {
      return (slots || []).map((slot) => {
        const val = overrides && overrides[slot] !== undefined ? overrides[slot] : this.specVal(sku, slot);
        return val ? { label: this.tr('spec_' + (SPEC_LABEL[slot] || slot)), value: val } : null;
      }).filter(Boolean);
    }
    rackSku(rack, usable) { return rack.id === 'sqst' ? sqstVariant(usable).sku : rack.sku; }
    rackDims(rack, usable) {
      const sku = this.rackSku(rack, usable);
      const b = cmOf(this.specVal(sku, 'breite')) || rack.fp[0];
      const t = cmOf(this.specVal(sku, 'tiefe')) || rack.fp[1];
      const h = rack.id === 'sqst' ? sqstVariant(usable).h : (cmOf(this.specVal(sku, 'hoehe')) || rack.h);
      return { b, t, h };
    }
    requiredSkus() {
      const s = new Set();
      FLOORS.forEach((f) => Object.values(f.skus).forEach((x) => s.add(x)));
      RACKS.forEach((r) => (r.variants ? r.variants.forEach((x) => s.add(x.sku)) : s.add(r.sku)));
      BARS.forEach((b) => s.add(b.sku));
      PLATES.forEach((p) => Object.values(p.items).forEach((l) => l.forEach(([x]) => s.add(x))));
      s.add(CP_SKU);
      BENCHES.forEach((b) => s.add(b.sku));
      HEX.forEach((h) => h.items.forEach(([x]) => s.add(x)));
      Object.values(KB_LINES).forEach((l) => l.start.concat(l.big).forEach(([x]) => s.add(x)));
      PULLUPS.forEach((p) => s.add(p.sku));
      EXTRAS.forEach((e) => s.add(e.sku));
      Object.values(STORAGE).forEach((x) => s.add(x));
      return Array.from(s);
    }
    readSource() {
      const out = {};
      try {
        const q = new URLSearchParams(window.location.search);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'placement'].forEach((k) => { if (q.get(k)) out[k] = q.get(k); });
      } catch (e) { /* ohne Herkunft weiter */ }
      if (document.referrer) {
        try { const r = new URL(document.referrer); if (r.host !== window.location.host) out.referrer = r.origin + r.pathname; } catch (e) { /* ignorieren */ }
      }
      return out;
    }

    /* ----- Regeln, die den Katalog brauchen ----- */
    // Die Farbwahl filtert die Bodenkacheln wie die Linienwahl die Scheiben: gezeigt wird, was es in der Farbe gibt.
    floorColours() { return ['blk', 'gry'].filter((c) => this.floorsIn(c).length); }
    floorIn(f, c) { return this.offered([[f.skus[c], 1]]); }
    floorsIn(c) {
      const all = FLOORS.filter((f) => f.skus[c] && this.listed([[f.skus[c], 1]]));
      // Der Ersatz (CORE 15 Tile) erscheint nur, solange der Puzzle in dieser Farbe nicht lagernd ist.
      return all.filter((f) => !f.fallbackFor || !all.some((x) => x.id === f.fallbackFor && this.floorIn(x, c)));
    }
    // Gibt es den gewaehlten Boden in der Farbe nicht, gilt der erste Boden dieser Farbe; die Wahl selbst bleibt fuer den Rueckweg stehen.
    floorPick(sel) {
      const cols = this.floorColours();
      const colour = cols.indexOf(sel.colour) >= 0 ? sel.colour : (cols[0] || 'blk');
      const list = this.floorsIn(colour);
      // Puzzle und sein Ersatz gelten als dieselbe Wahl: wechselt die Farbe, rueckt der jeweils lagernde nach.
      const chosen = FLOORS.find((f) => f.id === sel.floor);
      const partner = (f) => chosen && (f.fallbackFor === chosen.id || chosen.fallbackFor === f.id);
      const floor = sel.floor === 'none' ? null : (list.find((f) => f.id === sel.floor) || list.find((f) => partner(f) && this.floorIn(f, colour)) || list.find((f) => this.floorIn(f, colour)) || list[0] || null);
      return { floor, colour, list, cols };
    }
    floorThick(sel) { const f = this.floorPick(sel).floor; return f ? f.thick : 0; }
    plateImg(p, line) { const l = p.items[line === 'black' ? 'black' : 'color']; return this.img(l[l.length - 1][0]); }
    plateItems(p, line) { return p.items[line === 'black' ? 'black' : 'color'].concat([[CP_SKU, 1]]); }
    rackState(rack, room, usable) {
      const fix = room.fix;
      const d = this.rackDims(rack, usable);
      const fl = fitLevel(usable, d.h);
      let ok = fl.level !== 'no';
      const warns = [];
      if (fl.level !== 'ok') warns.push(this.fitText(usable, d.h));
      if (rack.needsWall) {
        if (fix === 'floor' || fix === 'none') { ok = false; warns.unshift(this.tr('warn_needs_wall')); }
        else if (fix === 'unknown') warns.unshift(this.tr('warn_cwr_unsure'));
      }
      if (rack.needsAnchor) {
        if (fix === 'none') { ok = false; warns.unshift(this.tr('warn_needs_anchor')); }
        else if (fix !== 'floor') warns.unshift(this.tr('warn_cpr100'));
      }
      return { ok, warn: warns.filter(Boolean).join(' '), dims: d };
    }
    pullState(p, room, usable) {
      let ok = true, warn = '';
      if (p.needsWall && (room.fix === 'floor' || room.fix === 'none')) { ok = false; warn = this.tr('warn_needs_wall'); }
      else if (p.needsWall && room.fix === 'unknown') warn = this.tr('warn_wpus_unsure');
      if (p.id === 'sqstpu') { const fl = fitLevel(usable, p.h); ok = fl.level !== 'no'; warn = fl.level === 'ok' ? '' : this.fitText(usable, p.h); }
      return { ok, warn };
    }
    defaults(training, room) {
      const facts = roomFacts(room);
      const d = { floor: 'none', colour: 'blk', rack: 'none', bar: 'none', plates: 'none', line: 'color', bench: 'nobench',
        hex: 'none', kbLine: 'cokb', kb: 'none', pullup: 'none', extras: [], storage: false };
      const cols = this.floorColours();
      const col0 = cols.find((c) => this.floorsIn(c).some((f) => this.floorIn(f, c)));
      if (col0) { d.colour = col0; d.floor = this.floorsIn(col0).find((f) => this.floorIn(f, col0)).id; }
      const usable = usableHeight(room, facts, this.floorThick(d));
      if (training === 'A') {
        const order = RACK_ORDER[room.fix] || RACK_ORDER.unknown;
        const hit = order.map((id) => RACKS.find((r) => r.id === id))
          .find((r) => this.offered([[this.rackSku(r, usable), 1]]) && this.rackState(r, room, usable).ok);
        d.rack = hit ? hit.id : 'none';
        const barPref = facts.maxSide < 400 ? ['bbh15', 'bb20', 'bb15'] : ['bb20', 'bbh15', 'bb15'];
        d.bar = barPref.find((id) => this.offered([[BARS.find((b) => b.id === id).sku, 1]])) || 'none';
        d.plates = ['p70', 'p150'].find((id) => this.offered(this.plateItems(PLATES.find((p) => p.id === id), 'color'))) || 'none';
        d.bench = this.offered([['HG-FBNCH', 1]]) ? 'flat' : 'nobench';
        d.kbLine = 'cokb';
      }
      if (training === 'B') {
        d.hex = this.offered(HEX[0].items) ? 'start' : 'none';
        d.kbLine = 'pckb';
        d.kb = this.offered(KB_LINES.pckb.start) ? 'start' : 'none';
        // Klimmzuege: die Empfehlung ist auch vorausgewaehlt. Das Wandsystem nur bei bestaetigter Wand.
        const puOrder = room.fix === 'wall' ? ['wpus', 'sqstpu'] : ['sqstpu'];
        const pu = puOrder.map((id) => PULLUPS.find((x) => x.id === id)).find((x) => this.offered([[x.sku, 1]]) && this.pullState(x, room, usable).ok);
        d.pullup = pu ? pu.id : 'none';
      }
      return d;
    }

    /* ----- Zustand ----- */
    facts() { return roomFacts(this.s.room); }
    sel() { return this.s.sel || this.defaults(this.s.training || 'A', this.s.room); }
    // Eine bewusst gewaehlte Option, die nach einer Aenderung nicht mehr passt, wird durch die neue Empfehlung ersetzt.
    fixInvalid(sel, room, d) {
      const usable = usableHeight(room, roomFacts(room), this.floorThick(sel));
      if (this.s.training === 'A') {
        const r = RACKS.find((x) => x.id === sel.rack);
        if (r && !this.rackState(r, room, usable).ok) { this.s.replaced = { key: 'rack', name: this.pName(r.id) }; delete this.s.touched.rack; sel.rack = d.rack; }
      }
      if (this.s.training === 'B') {
        const pu = PULLUPS.find((x) => x.id === sel.pullup);
        if (pu && !this.pullState(pu, room, usable).ok) { this.s.replaced = { key: 'pullup', name: this.pName(pu.key) }; delete this.s.touched.pullup; sel.pullup = d.pullup; }
      }
    }
    // Nach dem Senden geaendert: wieder sendbar. Neue ID, sonst haelt n8n die zweite Anfrage fuer eine Wiederholung.
    afterChange() {
      const st = this.s.send.state;
      if (st === 'ok') { this.s.prevConfigId = this.s.configId; this.s.configId = uuid(); }
      if (st === 'ok' || st === 'test' || st === 'fail') this.s.send = { state: 'idle' };
    }
    setRoom(k, v, quiet) {
      this.s.roomTouched[k] = true;
      this.afterChange();
      const room = Object.assign({}, this.s.room, { [k]: v });
      if (k === 'shape' && v === 'angled') room.area = Math.min(room.area, room.l * room.w / 10000);
      if ((k === 'l' || k === 'w') && room.shape === 'angled') room.area = Math.min(room.area, room.l * room.w / 10000);
      this.s.room = room;
      if (this.s.training) {
        const d = this.defaults(this.s.training, room);
        const sel = Object.assign({}, this.s.sel || d);
        Object.keys(d).forEach((key) => { if (!this.s.touched[key]) sel[key] = d[key]; });
        this.fixInvalid(sel, room, d);
        this.s.sel = sel;
      }
      if (!quiet) this.render();
    }
    setSel(patch) {
      Object.keys(patch).forEach((k) => { this.s.touched[k] = true; });
      if (this.s.replaced && patch[this.s.replaced.key] !== undefined) this.s.replaced = null;
      this.afterChange();
      const next = Object.assign({}, this.sel(), patch);
      if (patch.floor !== undefined || patch.colour !== undefined) this.fixInvalid(next, this.s.room, this.defaults(this.s.training || 'A', this.s.room));
      this.s.sel = next;
      this.s.cart = { state: 'idle' };
      this.render();
    }
    goStep(n) {
      if (n < 1 || n > 5) return;
      if (n > 2 && !this.s.training) return;
      this.s.step = n; this.s.info = null;
      // Nur Vorschlag und Ergebnis, je einmal: das reicht fuer den Trichter und kostet wenig Requests.
      if (n === 3 && !this.s.seenProposal) { this.s.seenProposal = true; track('hgc_step', { hgc_path: this.gaPath(), hgc_step: 'vorschlag' }); }
      if (n === 5 && !this.s.seenResult) { this.s.seenResult = true; track('hgc_step', { hgc_path: this.gaPath(), hgc_step: 'ergebnis' }); }
      this.render();
      const top = this.els.steps.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) this.els.steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ----- Berechnung: Positionen, Summe ----- */
    sum() {
      const s = this.s, sel = this.sel(), room = s.room, facts = this.facts(), training = s.training || 'A';
      const lines = [];
      const { floor, colour } = this.floorPick(sel);
      const qty = Math.ceil(Math.round(facts.area * facts.factor * 1000) / 1000);
      const usable = usableHeight(room, facts, this.floorThick(sel));
      const push = (block, option, name, sub, items, img) => {
        const total = this.itemsPrice(items);
        lines.push({ block, option, name, sub, items, img, total, missing: total === null, avail: total !== null && this.offered(items) });
      };
      if (floor && qty > 0) push('floor', floor.id, this.pName(floor.id) + ' · ' + this.tr(colour === 'gry' ? 'grey' : 'black'), qty + ' × 1 m²', [[floor.skus[colour], qty]], this.img(floor.skus[colour]));
      if (training === 'A') {
        const rack = RACKS.find((r) => r.id === sel.rack);
        if (rack) { const sku = this.rackSku(rack, usable); push('rack', rack.id, this.pName(rack.id) + (rack.id === 'sqst' ? ' ' + sqstVariant(usable).h : ''), sku, [[sku, 1]], this.img(sku)); }
        const bar = BARS.find((b) => b.id === sel.bar);
        if (bar) push('bar', bar.id, this.pName(bar.id), bar.sku, [[bar.sku, 1]], this.img(bar.sku));
        const pl = PLATES.find((p) => p.id === sel.plates);
        if (pl) {
          const items = pl.items[sel.line === 'black' ? 'black' : 'color'];
          push('plates', pl.id, 'HG ' + (sel.line === 'black' ? 'Black' : 'Color') + ' ' + this.pName(pl.id), this.pOpt(pl.id, 'sub'), items, this.plateImg(pl, sel.line === 'black' ? 'black' : 'color'));
          push('change_plates', 'cp', this.pName('cp'), this.pOpt('cp', 'sub'), [[CP_SKU, 1]], this.img(CP_SKU));
        }
        const be = BENCHES.find((b) => b.id === sel.bench);
        if (be) push('bench', be.id, this.pName(be.id), be.sku, [[be.sku, 1]], this.img(be.sku));
      }
      const hex = HEX.find((h) => h.id === sel.hex);
      if (hex) { push('hex', hex.id, this.pName(hex.key), this.pOpt(hex.key, 'sub'), hex.items, this.img(hex.items[hex.items.length - 1][0])); lines[lines.length - 1].zoom = hex.items.length > 1; }
      const kbl = KB_LINES[sel.kbLine];
      if (sel.kb !== 'none' && kbl) {
        const items = sel.kb === 'big' ? kbl.big : kbl.start;
        push('kb', sel.kbLine + '_' + sel.kb, this.tr('kb_' + sel.kbLine) + ' ' + (sel.kb === 'big' ? '8–32 kg' : '8/12/16 kg'), this.pOpt(sel.kb === 'big' ? 'kb_big' : 'kb_start', 'sub'), items, this.img(items[items.length - 1][0]));
      }
      const pu = PULLUPS.find((p) => p.id === sel.pullup);
      if (training === 'B' && pu) push('pullup', pu.id, this.pName(pu.key), pu.sku, [[pu.sku, 1]], this.img(pu.sku));
      (sel.extras || []).forEach((id) => { const e = EXTRAS.find((x) => x.id === id); if (e && (!e.onlyB || training === 'B')) push('extra', e.id, this.pName(e.id), e.sku, [[e.sku, 1]], this.img(e.sku)); });
      const st = this.storageCalc();
      if (st.any && sel.storage) {
        if (st.big) lines.push({ block: 'storage', option: 'big', name: this.tr('storage_line', { n: st.n }), sub: this.tr('storage_big'), items: [], img: this.img(STORAGE.db), total: null, missing: true, avail: false });
        else push('storage', st.up === STORAGE.upS ? 'short' : 'long', this.tr('storage_line', { n: st.n }), st.items.map(([k, q]) => q + '× ' + k).join(', '), st.items, this.img(STORAGE.db));
      }
      const total = lines.reduce((a, l) => a + (l.total || 0), 0);
      return {
        lines, total, count: lines.length, floorQty: qty, usable, colour,
        unavailable: lines.filter((l) => !l.missing && !l.avail).length,
        missing: lines.filter((l) => l.missing).length,
      };
    }
    // Ein Regal = 2 Pfosten + Ablagen (Odoo-Stueckliste). Bis 3 Ebenen tiefe Pfosten, 4 Ebenen hohe.
    storageCalc() {
      const sel = this.sel();
      const hex = HEX.find((h) => h.id === sel.hex);
      const kbl = KB_LINES[sel.kbLine];
      const rows = [];
      let db = 0, kb = 0;
      if (hex) { db = Math.ceil(hex.width / SHELF_CM); rows.push({ name: this.tr('storage_db'), sub: this.tr('storage_width', { w: this.fmt1(hex.width) }), qty: db }); }
      if (sel.kb !== 'none' && kbl) { const w = sel.kb === 'big' ? kbl.wBig : kbl.wStart; kb = Math.ceil(w / SHELF_CM); rows.push({ name: this.tr('storage_kb'), sub: this.tr('storage_width', { w: this.fmt1(w) }), qty: kb }); }
      const n = db + kb;
      if (!n) return { any: false };
      if (n > 4) return { any: true, big: true, n, db, kb, rows };
      const up = n <= 3 ? STORAGE.upS : STORAGE.upL;
      rows.push({ name: this.tr(n <= 3 ? 'storage_up_s' : 'storage_up_l'), sub: this.tr(n <= 3 ? 'storage_up_sub_s' : 'storage_up_sub_l'), qty: 2 });
      const items = [];
      if (db) items.push([STORAGE.db, db]);
      if (kb) items.push([STORAGE.kb, kb]);
      items.push([up, 2]);
      if (!this.listed(items)) return { any: false };
      return { any: true, big: false, n, db, kb, rows, up, items, price: this.itemsPrice(items), out: !this.offered(items) };
    }
    openPoints(sum) {
      const s = this.s, sel = this.sel(), room = s.room, facts = this.facts(), training = s.training;
      const out = [];
      const hasHang = training === 'B' ? sel.pullup !== 'none' : (training === 'A' && sel.rack !== 'none');
      const st = this.storageCalc();
      const storageBig = !!(st.any && st.big && sel.storage);
      if (facts.H === null) out.push(['op_h_unknown']);
      else if (sum.usable !== null && sum.usable < 235 && training === 'A' && sel.rack !== 'none') out.push(['op_h_low', { u: this.fmt1(sum.usable) }]);
      if (training === 'A' && room.fix === 'unknown' && sel.rack !== 'none') out.push(['op_fix_unknown']);
      if (room.fix === 'unknown' && ((training === 'A' && sel.rack === 'cwr1') || (training === 'B' && sel.pullup === 'wpus'))) out.push(['op_wall']);
      if (training === 'A' && sel.rack === 'cpr100' && room.fix !== 'floor') out.push(['op_cpr100']);
      if (training === 'A' && sel.rack === 'apex') out.push(['op_apex']);
      if ((sel.extras || []).includes('rings') && !hasHang) out.push(['op_rings']);
      if (room.use === 'drop' && room.neigh && room.neigh !== 'keine') out.push(['op_noise']);
      if (!s.roomTouched.l && !s.roomTouched.w) out.push(['op_room_default', { l: this.fmt1(room.l / 100), w: this.fmt1(room.w / 100) }]);
      if (storageBig) out.push(['op_storage_big']);
      if (sum.unavailable) out.push(['unavailable', { n: sum.unavailable }]);
      const missing = sum.missing - (storageBig ? 1 : 0);
      if (missing > 0) out.push(['op_missing', { n: missing }]);
      return out.map(([key, vars]) => ({ key, text: key === 'unavailable' ? this.plural('unavailable', vars.n) : this.tr(key, vars) }));
    }
    rackAdvice(sum) {
      const s = this.s, sel = this.sel(), room = s.room;
      const rack = RACKS.find((r) => r.id === sel.rack);
      if (!rack) return null;
      if (s.touched.rack) return this.tr('adv_rack_own', { name: this.pName(rack.id), fuer: this.pOpt(rack.id, 'fuer') });
      if (rack.id === 'cwr1') return this.tr('adv_wall_yes');
      if (rack.id === 'cpr150') return this.tr(({ wall: 'adv_wall_cpr150', floor: 'adv_wall_no', unknown: 'adv_wall_unsure' })[room.fix] || 'adv_wall_no');
      if (rack.id === 'sqst') return room.fix === 'none' ? this.tr('adv_movable') : this.tr('adv_sqst_low', { u: this.fmt1(sum.usable), h: sqstVariant(sum.usable).h });
      return null;
    }
    dropAdvice() {
      const room = this.s.room;
      if (room.use !== 'drop') return null;
      const thick = this.floorThick(this.sel());
      const floor = this.tr(thick >= 2.5 ? 'adv_drop_25' : (thick > 0 ? 'adv_drop_15' : 'adv_drop_nofloor'));
      return floor + ' ' + this.tr(room.neigh === 'darunter' ? 'adv_drop_below' : 'adv_drop_neigh');
    }
    advice(sum) {
      const s = this.s, sel = this.sel(), room = s.room, facts = this.facts(), training = s.training, step = s.step;
      const out = [];
      if (!training) return out;
      const rack = RACKS.find((r) => r.id === sel.rack);
      const heightLine = () => {
        if (facts.H === null) return this.tr('adv_height_unknown');
        const sqstLow = rack && rack.id === 'sqst' && room.fix !== 'none' && !s.touched.rack;   // sagt rackAdvice schon
        if (training === 'A' && rack && !sqstLow && sum.usable !== null && sum.usable < 235) return this.tr('adv_height_low', { u: this.fmt1(sum.usable), name: this.pName(rack.id) + (rack.id === 'sqst' ? ' ' + sqstVariant(sum.usable).h : ''), h: this.rackDims(rack, sum.usable).h });
        return null;
      };
      if (step <= 3) {
        if (training === 'A') {
          out.push(this.rackAdvice(sum));
          const barRule = facts.maxSide < 400 ? 'bbh15' : 'bb20';
          if (sel.bar === barRule) out.push(this.tr(facts.maxSide < 400 ? 'adv_bar_short' : 'adv_bar_long'));
        }
        if (training === 'B') out.push(this.tr('adv_b'));
        out.push(this.dropAdvice());
        out.push(heightLine());
      } else {
        if (training === 'A') out.push(this.tr('adv_extras_a'));
        if (training === 'B') out.push(this.tr(room.fix === 'wall' ? 'adv_pullup_wall' : 'adv_pullup_free'));
        if (this.storageCalc().any) out.push(this.tr('adv_storage'));
        out.push(this.tr('adv_start'));
      }
      return out.filter(Boolean).slice(0, 4);
    }
    fitText(usable, h) {
      const f = fitLevel(usable, h);
      if (f.level === 'unknown') return this.tr('fit_unknown');
      if (f.level === 'check') return this.tr('fit_check');
      if (f.level === 'no') return this.tr('fit_no', { h, u: this.fmt1(usable) });
      if (f.level === 'tight') return this.tr('fit_tight', { r: this.fmt1(f.rest) });
      return '';
    }

    /* ----- Rendering ----- */
    render() {
      const sum = this.sum();
      this.classList.toggle('is-compact', this.s.step > 1);
      this.renderSteps();
      this.els.main.innerHTML = this.renderMain(sum) + this.navHtml();
    }
    renderSteps() {
      const s = this.s;
      this.els.steps.innerHTML = [1, 2, 3, 4, 5].map((n) => {
        const active = s.step === n, done = s.step > n, reachable = n === 1 || !!s.training;
        const cls = 'ceq-hgc__step' + (active ? ' is-active' : '') + (done ? ' is-done' : '');
        return '<button type="button" class="' + cls + '" data-act="step" data-val="' + n + '"' + (reachable ? '' : ' disabled') + (active ? ' aria-current="step"' : '') + '>' +
          '<span class="ceq-hgc__step-n" data-n="' + n + '">' + esc(this.tr('step')) + ' ' + n + '</span><span class="ceq-hgc__step-l">' + esc(this.tr('step_' + n)) + '</span></button>';
      }).join('');
    }
    // Zurueck/Weiter im Fluss unter dem Schritt. In Schritt 1 ist die Kachel selbst der Weiter-Knopf
    // (Simon 21.09.: ein zusaetzlicher Button daneben war ueberfluessig und irritierte).
    navHtml() {
      const step = this.s.step;
      if (step === 1) return '';
      const labels = ['next_room', 'next_proposal', 'next_extras', 'next_result'];
      return '<div class="ceq-hgc__nav">' +
        '<button type="button" class="ceq-hgc__btn ceq-hgc__btn--secondary" data-act="back">' + esc(this.tr('back')) + '</button>' +
        (step < 5 ? '<button type="button" class="ceq-hgc__btn ceq-hgc__btn--primary" data-act="next">' + esc(this.tr(labels[step - 1])) + '</button>' : '') +
        '</div>';
    }
    renderMain(sum) {
      switch (this.s.step) {
        case 1: return this.viewTraining();
        case 2: return this.viewRoom(sum);
        case 3: return this.viewProposal(sum);
        case 4: return this.viewExtras(sum);
        default: return this.viewResult(sum);
      }
    }

    /* Bausteine */
    seg(opts, cur, act, key) {
      return '<div class="ceq-hgc__seg" role="group">' + opts.map((o) =>
        '<button type="button" class="ceq-hgc__seg-opt' + (cur === o.id ? ' is-on' : '') + '" aria-pressed="' + (cur === o.id) + '" data-act="' + act + '" data-key="' + key + '" data-val="' + esc(o.id) + '">' + esc(o.label) + '</button>'
      ).join('') + '</div>';
    }
    // Quer liegende Auswahlkachel: Bild links, rechts Name, Nutzen, Eigenschaften, Preis.
    opt(o, key, cur, cfg) {
      const multi = cfg && cfg.multi;
      const on = multi ? !!o.on : cur === o.id;
      const cls = 'ceq-hgc__opt' + (on ? ' is-on' : '') + (o.ok === false ? ' is-dim' : '') + (o.none ? ' is-none' : '');
      const priceText = o.price === null ? this.tr('price_open') : (o.price ? 'CHF ' + chf(o.price) : this.tr('no_cost'));
      const infoKey = key + ':' + o.id;
      const infoOpen = this.s.info === infoKey;
      const facts = o.facts || [];
      const specs = o.specs || [];
      const role = multi ? 'checkbox' : 'radio';
      return '<div class="' + cls + '" role="' + role + '" tabindex="' + (o.ok === false ? '-1' : '0') + '" aria-checked="' + on + '"' + (o.ok === false ? ' aria-disabled="true"' : '') + ' data-act="' + ((cfg && cfg.act) || 'sel') + '" data-key="' + key + '" data-val="' + esc(o.id) + '">' +
        '<div class="ceq-hgc__opt-img' + (o.img ? '' : ' is-empty') + (o.zoom ? ' is-zoom' : '') + '"' + (o.img ? ' style="background-image:url(\'' + esc(o.img) + '\')"' : '') + '>' +
          (o.rec && o.ok !== false ? '<span class="ceq-hgc__badge">' + esc(this.tr('recommended')) + '</span>' : '') +
          (o.out ? '<span class="ceq-hgc__badge ceq-hgc__badge--out">' + esc(this.tr('soldout_badge')) + '</span>' : '') +
          (o.none ? '<span class="ceq-hgc__opt-dash" aria-hidden="true">–</span>' : '') + '</div>' +
        '<div class="ceq-hgc__opt-body">' +
          '<div class="ceq-hgc__opt-head"><div class="ceq-hgc__opt-name">' + esc(o.name) + '</div><span class="ceq-hgc__mark ceq-hgc__mark--' + role + '" aria-hidden="true"></span></div>' +
          (o.fuer ? '<div class="ceq-hgc__opt-fuer">' + esc(o.fuer) + '</div>' : '') +
          (specs.length ? '<dl class="ceq-hgc__specs">' + specs.map((r) => '<div><dt>' + esc(r.label) + '</dt><dd>' + esc(r.value) + '</dd></div>').join('') + '</dl>' : '') +
          (o.warn ? '<div class="ceq-hgc__opt-warn">' + esc(o.warn) + '</div>' : '') +
          (o.out ? '<div class="ceq-hgc__opt-out">' + esc(this.tr('soldout_note')) + '</div>' : '') +
          '<div class="ceq-hgc__opt-foot"><div class="ceq-hgc__opt-price">' + esc(priceText) + '</div>' +
            (facts.length ? '<button type="button" class="ceq-hgc__opt-info" data-act="info" data-val="' + esc(infoKey) + '" aria-expanded="' + infoOpen + '">' + esc(this.tr(infoOpen ? 'less' : 'why_this')) + '</button>' : '') + '</div>' +
          (infoOpen && facts.length ? '<ul class="ceq-hgc__facts">' + facts.map((f) => '<li>' + esc(f) + '</li>').join('') + '</ul>' : '') +
        '</div></div>';
    }
    opts(list, key, cur, cfg) {
      const multi = cfg && cfg.multi;
      const wrap = (html) => '<div class="ceq-hgc__opts" role="' + (multi ? 'group' : 'radiogroup') + '">' + html + '</div>';
      const tile = (o) => this.opt(o, key, cur, cfg);
      if (multi) return wrap(list.map(tile).join(''));
      // Die Empfehlung steht zuoberst, «Keine …» zuunterst. Auf dem Handy klappen die Alternativen ein (die Seite waere
      // sonst rund sieben Bildschirme lang), am Desktop ist alles sichtbar und es gibt keinen Knopf (Simon 22.09.).
      const top = (o) => !!o.rec && o.ok !== false && !o.none;
      const recs = list.filter(top), nones = list.filter((o) => o.none), rest = list.filter((o) => !top(o) && !o.none);
      const picked = rest.filter((o) => o.id === cur), alts = rest.filter((o) => o.id !== cur);
      if (!recs.length || !alts.length || !this.mobile.matches) return wrap(recs.concat(rest, nones).map(tile).join(''));
      const open = !!this.s.openZones[key];
      const btn = '<button type="button" class="ceq-hgc__more" data-act="more" data-val="' + esc(key) + '" aria-expanded="' + open + '">' + esc(open ? this.tr('less_alt') : this.plural('more_alt', alts.length)) + '</button>';
      return wrap(recs.concat(picked).map(tile).join('') + (open ? alts.map(tile).join('') : '') + btn + nones.map(tile).join(''));
    }
    noneOpt(nameKey, id) { return { id: id || 'none', none: true, name: this.pName(nameKey), fuer: this.pOpt(nameKey, 'fuer'), price: 0 }; }
    zone(title, lines, body) {
      const sub = (lines || []).filter(Boolean);
      return '<section class="ceq-hgc__zone"><div class="ceq-hgc__zone-h"><h3 class="ceq-hgc__zone-title">' + esc(title) + '</h3>' +
        (sub.length ? '<p class="ceq-hgc__zone-sub">' + sub.map(esc).join(' · ') + '</p>' : '') + '</div>' + body + '</section>';
    }
    berater(lines) {
      return '<div class="ceq-hgc__berater"><div class="ceq-hgc__berater-head"><span class="ceq-hgc__avatar">' + AVATAR_SVG + '</span><div><b>' + esc(this.tr('berater_title')) + '</b><small>' + esc(this.tr('berater_sub')) + '</small></div></div>' +
        lines.map((l) => '<p>' + esc(l) + '</p>').join('') + '</div>';
    }
    twocol(main, side, wide) { return '<div class="ceq-hgc__twocol' + (wide ? ' ceq-hgc__twocol--wide' : '') + '"><div class="ceq-hgc__stack">' + main + '</div><aside class="ceq-hgc__side" data-hgc-side>' + side + '</aside></div>'; }
    h2(title, sub) { return '<div><h2 class="ceq-hgc__h2">' + esc(title) + '</h2>' + (sub ? '<p class="ceq-hgc__note ceq-hgc__sub">' + esc(sub) + '</p>' : '') + '</div>'; }

    // Massstaebliche Raumskizze ohne Produkte (Simon 21.09.). Rechteckig: die ganze Flaeche ist
    // Trainingsflaeche. Verwinkelt: L-Form mit exakt der eingestellten Flaeche; die ausgesparte Ecke hat
    // die Proportion des Raums -- die echte Form kennen wir nicht, darum «schematisch».
    planHtml() {
      const room = this.s.room, facts = this.facts();
      const max = this.mobile.matches ? { w: 300, h: 230 } : { w: 330, h: 250 };
      const Lc = num(room.l, 500), Wc = num(room.w, 400);
      const pad = 24;
      const sc = Math.min((max.w - pad) / Lc, (max.h - pad) / Wc);
      const w = Lc * sc, h = Wc * sc, x0 = pad, y0 = pad;
      const f = (n) => (Math.round(n * 10) / 10).toString();
      const angled = room.shape === 'angled' && facts.area < facts.rectArea - 0.01;
      let area, cut = '', lx = x0 + w / 2, ly = y0 + h / 2;
      if (angled) {
        const k = Math.sqrt(1 - facts.area / facts.rectArea);
        const cw = w * k, ch = h * k;
        const pts = [[0, 0], [w - cw, 0], [w - cw, ch], [w, ch], [w, h], [0, h]].map(([x, y]) => f(x0 + x) + ',' + f(y0 + y)).join(' ');
        area = '<polygon class="ceq-hgc__plan-area" points="' + pts + '"/>';
        cut = '<rect class="ceq-hgc__plan-cut" x="' + f(x0 + w - cw) + '" y="' + f(y0) + '" width="' + f(cw) + '" height="' + f(ch) + '"/>' +
          (cw > 60 && ch > 22 ? '<text class="ceq-hgc__plan-txt ceq-hgc__plan-txt--muted" x="' + f(x0 + w - cw / 2) + '" y="' + f(y0 + ch / 2) + '">' + esc(this.tr('plan_unused')) + '</text>' : '');
        // Beschriftung in den groesseren Teil der L-Form
        if (w * (h - ch) >= (w - cw) * ch) { lx = x0 + w / 2; ly = y0 + ch + (h - ch) / 2; } else { lx = x0 + (w - cw) / 2; ly = y0 + h / 2; }
      } else {
        area = '<rect class="ceq-hgc__plan-area" x="' + f(x0) + '" y="' + f(y0) + '" width="' + f(w) + '" height="' + f(h) + '"/>';
      }
      const svg = '<svg class="ceq-hgc__plan-svg" width="' + Math.round(w + pad + 2) + '" height="' + Math.round(h + pad + 2) + '" viewBox="0 0 ' + Math.round(w + pad + 2) + ' ' + Math.round(h + pad + 2) + '" role="img" aria-label="' + esc(this.tr('plan_title')) + '">' +
        cut + area +
        '<rect class="ceq-hgc__plan-room" x="' + f(x0) + '" y="' + f(y0) + '" width="' + f(w) + '" height="' + f(h) + '"/>' +
        '<text class="ceq-hgc__plan-dim" x="' + f(x0 + w / 2) + '" y="' + f(y0 - 8) + '">' + esc(this.fmt1(Lc / 100)) + ' m</text>' +
        '<text class="ceq-hgc__plan-dim" x="' + f(x0 - 8) + '" y="' + f(y0 + h / 2) + '" transform="rotate(-90 ' + f(x0 - 8) + ' ' + f(y0 + h / 2) + ')">' + esc(this.fmt1(Wc / 100)) + ' m</text>' +
        '<text class="ceq-hgc__plan-txt" x="' + f(lx) + '" y="' + f(ly) + '">' + esc(this.tr('plan_area', { a: this.fmt1(facts.area) })) + '</text>' +
        '</svg>';
      return '<div class="ceq-hgc__card ceq-hgc__plan-card"><div class="ceq-hgc__kicker">' + esc(this.tr('plan_title')) + '</div>' + svg +
        '<div class="ceq-hgc__plan-label">' + esc(this.tr('plan_label', { l: this.fmt1(Lc / 100), w: this.fmt1(Wc / 100), r: this.fmt1(facts.rectArea) })) + '</div>' +
        '<div class="ceq-hgc__note">' + esc(this.tr(angled ? 'plan_angled_note' : 'plan_rect_note', { a: this.fmt1(facts.area) })) + '</div></div>';
    }
    lineHtml(l, big) {
      const sub = l.sub + (l.missing || l.avail ? '' : ' · ' + this.tr('unavailable'));
      return '<div class="ceq-hgc__line' + (big ? ' ceq-hgc__line--big' : '') + '"><div class="ceq-hgc__line-l"><span class="ceq-hgc__thumb' + (l.img ? '' : ' is-empty') + (l.zoom ? ' is-zoom' : '') + '"' + (l.img ? ' style="background-image:url(\'' + esc(l.img) + '\')"' : '') + '></span>' +
        '<div class="ceq-hgc__line-n">' + esc(l.name) + '<small>' + esc(sub) + '</small></div></div>' +
        '<div class="ceq-hgc__line-p' + (l.missing ? ' is-muted' : '') + '">' + esc(l.missing ? this.tr('price_open') : 'CHF ' + chf(l.total)) + '</div></div>';
    }
    sumCard(sum) {
      return '<div class="ceq-hgc__card"><div class="ceq-hgc__card-h"><span>' + esc(this.tr('sum_title')) + '</span><span class="ceq-hgc__card-h-count">' + sum.count + ' ' + esc(this.tr('positions')) + '</span></div><div class="ceq-hgc__card-b">' +
        sum.lines.map((l) => this.lineHtml(l)).join('') +
        '<div class="ceq-hgc__line ceq-hgc__line--total"><div class="ceq-hgc__line-n">' + esc(this.tr('art_sum')) + '</div><div class="ceq-hgc__line-p">CHF ' + chf(sum.total) + '</div></div>' +
        '<div class="ceq-hgc__note ceq-hgc__fine">' + esc(this.tr('sum_note')) + '</div></div></div>';
    }

    /* Schritt 1 */
    viewTraining() {
      const s = this.s;
      const goals = [
        { id: 'A', name: this.tr('goal_a'), story: this.tr('goal_a_story'), sub: this.tr('goal_a_sub'), img: this.img('CPR-150') },
        { id: 'B', name: this.tr('goal_b'), story: this.tr('goal_b_story'), sub: this.tr('goal_b_sub'), img: this.img('PCKB-16') },
      ];
      const cards = goals.map((g) => {
        const on = s.training === g.id;
        return '<div class="ceq-hgc__goal' + (on ? ' is-on' : '') + '" role="radio" tabindex="0" aria-checked="' + on + '" data-act="goal" data-val="' + g.id + '">' +
          '<div class="ceq-hgc__goal-img' + (g.img ? '' : ' is-empty') + '"' + (g.img ? ' style="background-image:url(\'' + esc(g.img) + '\')"' : '') + '></div>' +
          '<div class="ceq-hgc__goal-body"><div class="ceq-hgc__opt-name ceq-hgc__goal-name">' + esc(g.name) + '</div><div class="ceq-hgc__note">' + esc(g.story) + '</div>' +
          '<div class="ceq-hgc__opt-sub">' + esc(g.sub) + '</div>' +
          '<div class="ceq-hgc__goal-cta">' + esc(this.tr(on ? 'goal_why' : 'goal_cta')) + ' <span aria-hidden="true">→</span></div></div></div>';
      }).join('');
      const main = this.h2(this.tr('q1'), this.tr('q1sub')) + '<p class="ceq-hgc__hint">' + esc(this.tr('q1_hint')) + '</p>' +
        '<div class="ceq-hgc__stack ceq-hgc__stack--tight" role="radiogroup">' + cards + '</div>';
      const side = '<div class="ceq-hgc__card ceq-hgc__card--pad"><div class="ceq-hgc__card-title">' + esc(this.tr('order_title')) + '</div><div class="ceq-hgc__note">' + esc(this.tr('order_text')) + '</div></div>' +
        this.berater([this.tr('not_asked')]);
      return this.twocol(main, side);
    }

    /* Schritt 2 */
    viewRoom(sum) {
      const s = this.s, room = s.room, facts = this.facts();
      // widest: laengster moeglicher Wert -- reserviert die Breite, damit der Wert beim Schieben nicht zwischen neben/unter dem Label springt
      const slider = (key, label, min, max, step, val, valText, widest) =>
        '<div class="ceq-hgc__slider"><div class="ceq-hgc__slider-top"><label class="ceq-hgc__lbl" for="hgc-' + key + '">' + esc(label) + '</label><div class="ceq-hgc__slider-val" data-hgc-val="' + key + '"' + (widest ? ' style="min-width:' + widest.length + 'ch"' : '') + '>' + esc(valText) + '</div></div>' +
        '<input class="ceq-hgc__rng" id="hgc-' + key + '" type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '" data-room="' + key + '"></div>';
      const areaMax = Math.max(4, Math.round(facts.rectArea));
      let body = '<div class="ceq-hgc__g3">' +
        slider('l', this.tr('length'), 200, 1000, 10, room.l, room.l + ' cm') +
        slider('w', this.tr('width'), 200, 800, 10, room.w, room.w + ' cm') +
        slider('h', this.tr('height'), 200, 320, 5, room.h, room.hUnknown ? '?' : room.h + ' cm') + '</div>';
      // Zweite Reihe, oben buendig: links die Form der Trainingsflaeche, rechts worauf die Hoehe gemessen wurde.
      const hOpts = [['before', 'h_before'], ['after', 'h_after'], ['unknown', 'h_unknown']].map(([id, key]) => {
        const on = id === 'unknown' ? room.hUnknown : (!room.hUnknown && room.hMeasured === id);
        return '<button type="button" class="ceq-hgc__seg-opt' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-act="hmeasure" data-val="' + id + '">' + esc(this.tr(key)) + '</button>';
      }).join('');
      body += '<div class="ceq-hgc__g12">' +
        '<div class="ceq-hgc__field"><div class="ceq-hgc__lbl">' + esc(this.tr('shape')) + '</div>' +
          this.seg([{ id: 'rect', label: this.tr('shape_rect') }, { id: 'angled', label: this.tr('shape_angled') }], room.shape, 'room', 'shape') +
          (room.shape === 'angled' ? slider('area', this.tr('train_area'), 4, areaMax, 0.5, Math.min(room.area, areaMax), this.fmt1(facts.area) + ' m²', this.fmt1(areaMax - 0.5) + ' m²') + '<div class="ceq-hgc__note ceq-hgc__fine">' + esc(this.tr('train_area_note')) + '</div>' : '') +
          // Auf dem Handy stuende die Skizze in der Seitenspalte erst nach dem ganzen Formular.
          '<div class="ceq-hgc__plan-inline" data-hgc-plan-inline>' + this.planHtml() + '</div>' +
        '</div>' +
        '<div class="ceq-hgc__field"><div class="ceq-hgc__lbl">' + esc(this.tr('h_measure')) + '</div>' +
          '<div class="ceq-hgc__seg ceq-hgc__seg--stack-m" role="radiogroup" aria-label="' + esc(this.tr('h_measure')) + '">' + hOpts + '</div>' +
          '<div class="ceq-hgc__note ceq-hgc__fine">' + esc(this.tr('h_note')) + '</div>' +
        '</div></div>';
      // Befestigung: vier Faelle, entscheiden die Rack- bzw. Klimmzugwahl
      body += '<div class="ceq-hgc__field"><div class="ceq-hgc__fix-title">' + esc(this.tr('fix_title')) + '</div>' +
        '<div class="ceq-hgc__note ceq-hgc__fine">' + esc(this.tr(s.training === 'B' ? 'fix_sub_b' : 'fix_sub_a')) + '</div>' +
        '<div class="ceq-hgc__radios" role="radiogroup" aria-label="' + esc(this.tr('fix_title')) + '">' + FIX_OPTS.map((id) => {
          const on = room.fix === id;
          return '<div class="ceq-hgc__radio' + (on ? ' is-on' : '') + '" role="radio" tabindex="0" aria-checked="' + on + '" data-act="room" data-key="fix" data-val="' + id + '">' +
            '<span class="ceq-hgc__mark ceq-hgc__mark--radio" aria-hidden="true"></span><span><b>' + esc(this.tr('fix_' + id)) + '</b><small>' + esc(this.tr('fix_' + id + '_sub')) + '</small></span></div>';
        }).join('') + '</div></div>';
      body += '<div class="ceq-hgc__g2 ceq-hgc__g2--top"><div class="ceq-hgc__field"><div class="ceq-hgc__lbl">' + esc(this.tr('use')) + '</div>' +
        this.seg([{ id: 'controlled', label: this.tr('use_controlled') }, { id: 'drop', label: this.tr('use_drop') }], room.use, 'room', 'use') + '</div>' +
        '<div class="ceq-hgc__field"><div class="ceq-hgc__lbl">' + esc(this.tr('neigh')) + '</div>' +
        this.seg([{ id: 'darunter', label: this.tr('neigh_below') }, { id: 'nebenan', label: this.tr('neigh_next') }, { id: 'keine', label: this.tr('neigh_none') }], room.neigh, 'room', 'neigh') + '</div></div>';
      const main = this.h2(this.tr('q2'), this.tr('q2sub')) + '<div class="ceq-hgc__card ceq-hgc__card--form">' + body + '</div>';
      return this.twocol(main, this.sideRoom(sum));
    }
    sideRoom(sum) { return this.planHtml() + this.berater(this.advice(sum)); }

    /* Schritt 3 */
    viewProposal(sum) {
      const s = this.s, sel = this.sel(), room = s.room, facts = this.facts(), training = s.training;
      const def = training ? this.defaults(training, room) : null;
      const usable = sum.usable;
      const fp = this.floorPick(sel);
      let main = this.h2(this.tr('q3'), this.tr('q3sub'));

      // Boden
      const floors = fp.list.map((f) => {
        const sku = f.skus[fp.colour];
        const unit = this.itemsPrice([[sku, 1]]);
        return { id: f.id, out: !this.offered([[sku, 1]]), name: this.pName(f.id), fuer: this.pOpt(f.id, 'fuer'), facts: this.pFacts(f.id, f.facts), img: this.img(sku),
          specs: this.specRows(sku, f.slots, { format: f.format }).concat(unit === null ? [] : [{ label: 'CHF/m²', value: chf(unit) }]),
          price: unit === null ? null : unit * sum.floorQty, rec: def && def.floor === f.id };
      }).concat([this.noneOpt('floor_none')]);
      const fac = facts.factor.toFixed(2);
      const floorMath = this.fmt1(facts.area) + ' m² × ' + (this.lang === 'de' ? fac.replace('.', ',') : fac) + ' = ' + this.fmt3(facts.area * facts.factor) + ' m² → ' + sum.floorQty + ' × 1 m²';
      const floorBody = (fp.cols.length > 1 ? '<div class="ceq-hgc__row">' + this.seg(fp.cols.map((c) => ({ id: c, label: this.tr(c === 'gry' ? 'grey' : 'black') })), fp.colour, 'sel', 'colour') + '</div>' : '') +
        this.opts(floors, 'floor', fp.floor ? fp.floor.id : 'none');
      main += this.zone(this.tr('zone_floor'), [this.tr('pick_one'), fp.floor ? floorMath : ''], floorBody);

      if (training === 'A') {
        const racks = RACKS.filter((r) => this.listed([[this.rackSku(r, usable), 1]])).map((r) => {
          const sku = this.rackSku(r, usable);
          const st = this.rackState(r, room, usable);
          return { id: r.id, out: !this.offered([[sku, 1]]), name: this.pName(r.id) + (r.id === 'sqst' ? ' ' + st.dims.h : ''), fuer: this.pOpt(r.id, 'fuer'), facts: this.pFacts(r.id, r.facts),
            specs: this.specRows(sku, ['breite', 'tiefe', 'hoehe'], r.id === 'sqst' ? { hoehe: st.dims.h + ' cm' } : null),
            img: this.img(sku), price: this.itemsPrice([[sku, 1]]), rec: def && def.rack === r.id, ok: st.ok, warn: st.warn };
        }).concat([this.noneOpt('rack_none')]);
        main += this.zone(this.tr('zone_rack'), [this.tr('pick_one')], this.replacedNote('rack') + this.opts(racks, 'rack', sel.rack));

        const bars = BARS.filter((b) => this.listed([[b.sku, 1]])).map((b) => ({ id: b.id, out: !this.offered([[b.sku, 1]]), name: this.pName(b.id), fuer: this.pOpt(b.id, 'fuer'), facts: this.pFacts(b.id, b.facts),
          specs: this.specRows(b.sku, ['laenge', 'gewicht', 'griff']), img: this.img(b.sku), price: this.itemsPrice([[b.sku, 1]]), rec: def && def.bar === b.id }))
          .concat([this.noneOpt('bar_none')]);
        main += this.zone(this.tr('zone_bar'), [this.tr('pick_one'), this.tr(facts.maxSide < 400 ? 'bar_rule_short' : 'bar_rule_long')], this.opts(bars, 'bar', sel.bar));

        const line = sel.line === 'black' ? 'black' : 'color';
        const plates = PLATES.filter((p) => this.listed(this.plateItems(p, line))).map((p) => {
          const items = this.plateItems(p, line);
          return { id: p.id, out: !this.offered(items), name: this.pName(p.id), fuer: this.pOpt(p.id, 'fuer'), facts: this.pFacts(p.id, p.facts), img: this.plateImg(p, line),
            specs: [{ label: this.tr('spec_inhalt'), value: this.pOpt(p.id, 'sub') + ' + ' + this.pOpt('cp', 'sub') }].concat(this.specRows(items[0][0], ['durchmesser', 'material'])),
            price: this.itemsPrice(items), rec: def && def.plates === p.id };
        }).concat([this.noneOpt('plates_none')]);
        main += this.zone(this.tr('plates'), [this.tr('pick_one'), this.tr('cp_note')],
          '<div class="ceq-hgc__row">' + this.seg([{ id: 'color', label: this.tr('line_color') }, { id: 'black', label: this.tr('line_black') }], sel.line, 'sel', 'line') + '</div>' +
          this.opts(plates, 'plates', sel.plates));

        const benches = BENCHES.filter((b) => this.listed([[b.sku, 1]])).map((b) => ({ id: b.id, out: !this.offered([[b.sku, 1]]), name: this.pName(b.id), fuer: this.pOpt(b.id, 'fuer'), facts: this.pFacts(b.id, b.facts),
          specs: this.specRows(b.sku, ['laenge', 'breite', 'hoehe']), img: this.img(b.sku), price: this.itemsPrice([[b.sku, 1]]), rec: def && def.bench === b.id }))
          .concat([this.noneOpt('nobench', 'nobench')]);
        main += this.zone(this.tr('zone_bench'), [this.tr('pick_one')], this.opts(benches, 'bench', sel.bench));
      }
      if (training === 'B') {
        main += this.zone(this.tr('zone_hex'), [this.tr('pick_one'), this.tr('hex_pairs')], this.opts(this.hexOpts(def), 'hex', sel.hex));
        main += this.zone(this.tr('zone_kb'), [this.tr('pick_one'), this.tr('kb_singles')], this.kbLineRow() + this.opts(this.kbOpts(def), 'kb', sel.kb));
      }
      const side = this.sumCard(sum) + this.berater(this.advice(sum));
      return this.twocol(main, side);
    }
    replacedNote(key) {
      const r = this.s.replaced;
      return r && r.key === key ? '<div class="ceq-hgc__note ceq-hgc__note--red" role="status">' + esc(this.tr('replaced_note', { name: r.name })) + '</div>' : '';
    }
    hexOpts(def) {
      return HEX.filter((h) => this.listed(h.items)).map((h) => ({ id: h.id, out: !this.offered(h.items), name: this.pName(h.key), fuer: this.pOpt(h.key, 'fuer'), img: this.img(h.items[h.items.length - 1][0]), zoom: h.items.length > 1,
        specs: [{ label: this.tr('spec_inhalt'), value: this.pOpt(h.key, 'sub') }].concat(this.specRows(h.items[0][0], ['kopf'])),
        price: this.itemsPrice(h.items), rec: def && def.hex === h.id }))
        .concat([this.noneOpt('hex_none')]);
    }
    kbOpts(def) {
      const sel = this.sel(); const kbl = KB_LINES[sel.kbLine];
      return KB.map((k) => ({ k, items: k.id === 'big' ? kbl.big : kbl.start })).filter((x) => this.listed(x.items)).map(({ k, items }) => ({
        id: k.id, out: !this.offered(items), name: this.pName(k.key), fuer: this.pOpt(k.key, 'fuer'), img: this.img(items[items.length - 1][0]),
        specs: [{ label: this.tr('spec_inhalt'), value: this.pOpt(k.key, 'sub') }].concat(this.specRows(items[0][0], kbl.slots)),
        price: this.itemsPrice(items), rec: def && def.kb === k.id && def.kbLine === sel.kbLine,
      })).concat([this.noneOpt('kb_none')]);
    }
    // Linienwahl als eigene Karten mit Bild — als Pillen-Zeile ging sie unter.
    kbLineRow() {
      const cur = this.sel().kbLine;
      return '<div class="ceq-hgc__field"><div class="ceq-hgc__lbl">' + esc(this.tr('kb_line')) + '</div><div class="ceq-hgc__lines" role="radiogroup">' +
        ['pckb', 'cokb'].map((id) => {
          const on = cur === id; const sku = KB_LINES[id].start[2][0];
          return '<div class="ceq-hgc__linecard' + (on ? ' is-on' : '') + '" role="radio" tabindex="0" aria-checked="' + on + '" data-act="sel" data-key="kbLine" data-val="' + id + '">' +
            '<span class="ceq-hgc__linecard-img"' + (this.img(sku) ? ' style="background-image:url(\'' + esc(this.img(sku)) + '\')"' : '') + '></span>' +
            '<span class="ceq-hgc__linecard-body"><b>' + esc(this.tr('kb_' + id)) + '</b><small>' + esc(this.tr('kb_' + id + '_why')) + '</small></span>' +
            '<span class="ceq-hgc__mark ceq-hgc__mark--radio" aria-hidden="true"></span></div>';
        }).join('') + '</div></div>';
    }

    /* Schritt 4 */
    viewExtras(sum) {
      const s = this.s, sel = this.sel(), room = s.room, training = s.training;
      let main = this.h2(this.tr('q4'), this.tr('q4sub'));
      if (training === 'A') {
        main += this.zone(this.tr('zone_hex'), [this.tr('pick_one'), this.tr('hex_pairs')], this.opts(this.hexOpts(null), 'hex', sel.hex));
        main += this.zone(this.tr('zone_kb'), [this.tr('pick_one'), this.tr('kb_singles')], this.kbLineRow() + this.opts(this.kbOpts(null), 'kb', sel.kb));
      }
      if (training === 'B') {
        const defB = this.defaults(training, room);
        const pulls = PULLUPS.filter((p) => this.listed([[p.sku, 1]])).map((p) => {
          const st = this.pullState(p, room, sum.usable);
          return { id: p.id, out: !this.offered([[p.sku, 1]]), name: this.pName(p.key), fuer: this.pOpt(p.key, 'fuer'), img: this.img(p.sku),
            specs: this.specRows(p.sku, p.slots, p.id === 'sqstpu' ? { hoehe: p.h + ' cm' } : null),
            price: this.itemsPrice([[p.sku, 1]]), rec: defB.pullup === p.id, ok: st.ok, warn: st.warn };
        }).concat([this.noneOpt('pu_none')]);
        main += this.zone(this.tr('zone_pullup'), [this.tr('pick_one')], this.replacedNote('pullup') + this.opts(pulls, 'pullup', sel.pullup));
      }
      const hasHang = training === 'B' ? sel.pullup !== 'none' : (training === 'A' && sel.rack !== 'none');
      const extras = EXTRAS.filter((e) => (!e.onlyB || training === 'B') && this.listed([[e.sku, 1]])).map((e) => ({
        id: e.id, out: !this.offered([[e.sku, 1]]), name: this.pName(e.id), fuer: this.pOpt(e.id, 'fuer'), img: this.img(e.sku), specs: this.specRows(e.sku, e.slots), price: this.itemsPrice([[e.sku, 1]]),
        warn: e.needsHang && !hasHang ? this.tr('warn_rings') : '', on: (sel.extras || []).includes(e.id),
      }));
      main += this.zone(this.tr('zone_extras'), [this.tr('pick_many'), this.tr('extras_sub')], this.opts(extras, 'extras', null, { multi: true, act: 'extra' }));
      const st = this.storageCalc();
      let stBody;
      if (st.any) {
        const stOpts = [{ id: 'yes', out: !!st.out, name: this.tr('storage_line', { n: st.n }), fuer: this.tr('storage_text'), img: this.img(STORAGE.db),
          specs: st.rows.map((r) => ({ label: r.name, value: r.qty + ' ×, ' + r.sub })), price: st.big ? null : st.price, warn: st.big ? this.tr('storage_big') : '' },
          this.noneOpt('storage_none')];
        stBody = this.opts(stOpts, 'storage', sel.storage ? 'yes' : 'none', { act: 'storage' });
      } else {
        stBody = '<div class="ceq-hgc__note ceq-hgc__note--grey">' + esc(this.tr('storage_none')) + '</div>';
      }
      main += this.zone(this.tr('zone_storage'), [], stBody);
      const side = this.sumCard(sum) + this.berater(this.advice(sum));
      return this.twocol(main, side);
    }

    /* Schritt 5: Uebersicht der Bestellung bzw. Anfrage, geordnet nach Produktgruppen */
    viewResult(sum) {
      const s = this.s;
      const ops = this.openPoints(sum);
      const goal = this.tr(s.training === 'B' ? 'goal_b' : 'goal_a');
      const GROUPS = [['floor', 'zone_floor'], ['rack', 'zone_rack'], ['bar', 'zone_bar'], ['plates', 'plates'], ['bench', 'zone_bench'],
        ['hex', 'zone_hex'], ['kb', 'zone_kb'], ['pullup', 'zone_pullup'], ['extra', 'zone_extras'], ['storage', 'zone_storage']];
      const groupOf = (b) => (b === 'change_plates' ? 'plates' : b);
      let rows = '';
      GROUPS.forEach(([g, label]) => {
        const ls = sum.lines.filter((l) => groupOf(l.block) === g);
        if (ls.length) rows += '<div class="ceq-hgc__group">' + esc(this.tr(label)) + '</div>' + ls.map((l) => this.lineHtml(l, true)).join('');
      });
      let main = this.h2(this.tr('setup_title', { goal }), this.tr('result_sub'));
      main += '<div class="ceq-hgc__card ceq-hgc__overview"><div class="ceq-hgc__card-h"><span>' + esc(this.tr('sum_title')) + '</span><span class="ceq-hgc__card-h-count">' + sum.count + ' ' + esc(this.tr('positions')) + '</span></div><div class="ceq-hgc__card-b">' +
        rows +
        '<div class="ceq-hgc__line ceq-hgc__line--big"><div class="ceq-hgc__line-n">' + esc(this.tr('shipping')) + '<small>' + esc(this.tr('shipping_sub')) + '</small></div><div class="ceq-hgc__line-p is-muted">' + esc(this.tr('separate')) + '</div></div>' +
        '<div class="ceq-hgc__line ceq-hgc__line--total"><div class="ceq-hgc__line-n">' + esc(this.tr('art_sum')) + '</div><div class="ceq-hgc__line-p">CHF ' + chf(sum.total) + '</div></div>' +
        '<div class="ceq-hgc__note ceq-hgc__fine">' + esc(this.tr('price_note')) + '</div></div></div><!--buy-->';
      const buy = '<div class="ceq-hgc__card ceq-hgc__card--pad ceq-hgc__total-card"><div class="ceq-hgc__line ceq-hgc__line--total"><div class="ceq-hgc__line-n">' + esc(this.tr('art_sum')) + '<small>' + sum.count + ' ' + esc(this.tr('positions')) + '</small></div><div class="ceq-hgc__line-p">CHF ' + chf(sum.total) + '</div></div>' +
        this.resultActions(sum) + '</div>';
      const narrow = this.narrow.matches;
      // Montage waehlbar. Mit Montage nur Anfrage: den Preis rechnen wir heute noch individuell (Simon 21.09.).
      main += '<div class="ceq-hgc__card ceq-hgc__card--pad"><div class="ceq-hgc__card-title">' + esc(this.tr('delivery_title')) + '</div>' +
        '<div class="ceq-hgc__note">' + esc(this.tr('delivery_text')) + '</div>' +
        '<div class="ceq-hgc__radios" role="radiogroup" aria-label="' + esc(this.tr('montage_title')) + '">' + [['no', 'montage_self'], ['yes', 'montage_us']].map(([id, key]) => {
          const on = (id === 'yes') === !!s.montage;
          return '<div class="ceq-hgc__radio' + (on ? ' is-on' : '') + '" role="radio" tabindex="0" aria-checked="' + on + '" data-act="montage" data-val="' + id + '">' +
            '<span class="ceq-hgc__mark ceq-hgc__mark--radio" aria-hidden="true"></span><span><b>' + esc(this.tr(key)) + '</b><small>' + esc(this.tr(key + '_sub')) + '</small></span></div>';
        }).join('') + '</div></div>';
      // Der Berater sagt hier nur noch, was offen ist (ersetzt die eigene Karte «Was noch nicht geklaert ist»).
      const openCard = '<div class="ceq-hgc__berater"><div class="ceq-hgc__berater-head"><span class="ceq-hgc__avatar">' + AVATAR_SVG + '</span><div><b>' + esc(this.tr('open_title')) + '</b><small>' + esc(this.tr(ops.length ? 'open_sub' : 'no_open')) + '</small></div></div>' +
        ops.map((o) => '<div class="ceq-hgc__note ceq-hgc__note--red">' + esc(o.text) + '</div>').join('') + '</div>';
      // Breit klebt die Kaufkarte in der Seitenspalte mit. Schmal steht sie direkt unter der Uebersicht, vor allem anderen.
      main = narrow ? main.replace('<!--buy-->', buy) : main.replace('<!--buy-->', '');
      main += openCard;
      let html = this.twocol(main, narrow ? '' : buy, true);
      if (s.consultOpen) html += '<div class="ceq-hgc__consult-wrap" data-hgc-consult>' + this.consultForm(sum, ops) + '</div>';
      return html;
    }
    resultActions(sum) {
      const s = this.s, c = s.cart;
      let h = '<div class="ceq-hgc__actions">';
      if (s.montage) {
        h += '<div class="ceq-hgc__note ceq-hgc__note--red">' + esc(this.tr('montage_cart_off')) + '</div>';
        h += '<button type="button" class="ceq-hgc__btn ceq-hgc__btn--primary ceq-hgc__btn--block" data-act="consult">' + esc(this.tr('to_consult_montage')) + '</button>';
      } else if (sum.unavailable) {
        h += '<div class="ceq-hgc__note ceq-hgc__note--red">' + esc(this.plural('soldout_cart_off', sum.unavailable)) + '</div>';
        h += '<button type="button" class="ceq-hgc__btn ceq-hgc__btn--primary ceq-hgc__btn--block" data-act="consult">' + esc(this.tr('to_consult_soldout')) + '</button>';
      } else {
        const inCart = !!s.cartSig && s.cartSig === this.cartSigOf(sum) && c.state !== 'busy';
        if (inCart) h += '<a class="ceq-hgc__btn ceq-hgc__btn--primary ceq-hgc__btn--block" href="' + esc(this.dataset.cartUrl || '/cart') + '">' + esc(this.tr('cart_view')) + '</a>' + (c.state === 'ok' ? '' : '<div class="ceq-hgc__note ceq-hgc__note--muted">' + esc(this.tr('cart_in')) + '</div>');
        else h += '<button type="button" class="ceq-hgc__btn ceq-hgc__btn--primary ceq-hgc__btn--block" data-act="cart"' + (c.state === 'busy' || !sum.count ? ' disabled' : '') + '>' + esc(this.tr(c.state === 'busy' ? 'cart_adding' : (s.cartSig ? 'cart_update' : 'to_cart'))) + '</button>';
        if (c.state === 'ok') {
          h += '<div class="ceq-hgc__toast" role="status"><div><b>' + esc(this.tr('cart_added_title')) + '</b><br>' + esc(this.tr('cart_added', { n: c.added, chf: chf(c.addedTotal) })) +
            (c.skipped ? '<br>' + esc(this.plural('cart_skipped', c.skipped)) : '') + '</div></div>';
        } else if (c.state === 'none') {
          h += '<div class="ceq-hgc__toast ceq-hgc__toast--err" role="status"><div>' + esc(this.tr('cart_none')) + '</div></div>';
        } else if (c.state === 'fail') {
          h += '<div class="ceq-hgc__toast ceq-hgc__toast--err" role="alert"><div><b>' + esc(this.tr('cart_fail_title')) + '</b><br>' + esc(this.tr('cart_fail', { phone: this.phone })) + (c.detail ? '<br><small>' + esc(c.detail) + '</small>' : '') + '</div></div>';
        }
        h += '<button type="button" class="ceq-hgc__btn ceq-hgc__btn--secondary ceq-hgc__btn--block" data-act="consult">' + esc(this.tr('to_consult')) + '</button>';
      }
      h += '<div class="ceq-hgc__note ceq-hgc__note--muted">' + esc(this.tr('consult_note')) + '</div></div>';
      return h;
    }
    consultForm(sum, ops) {
      const s = this.s, f = s.form, e = s.errors, send = s.send;
      if (send.state === 'ok') {
        return '<div class="ceq-hgc__card ceq-hgc__card--pad ceq-hgc__card--strong"><div class="ceq-hgc__toast" role="status"><div><b>' + esc(this.tr('sent_title')) + '</b><br>' + esc(this.tr('sent_text')) + '</div></div></div>';
      }
      const field = (name, label, type, req, auto) =>
        '<div class="ceq-hgc__field"><label class="ceq-hgc__lbl" for="hgc-f-' + name + '">' + esc(label) + (req ? ' *' : '') + '</label>' +
        '<input class="ceq-hgc__in' + (e[name] ? ' is-err' : '') + '" id="hgc-f-' + name + '" type="' + type + '" name="' + name + '" value="' + esc(f[name]) + '"' + (auto ? ' autocomplete="' + auto + '"' : '') + (req ? ' required aria-required="true"' : '') + (e[name] ? ' aria-invalid="true" aria-describedby="hgc-e-' + name + '"' : '') + ' data-form="' + name + '">' +
        (e[name] ? '<div class="ceq-hgc__err" id="hgc-e-' + name + '">' + esc(e[name]) + '</div>' : '') + '</div>';
      const photo = (key, label, hint) => {
        const p = s.photos[key];
        if (p) return '<div class="ceq-hgc__upload is-set"><b>' + esc(label) + '</b><span>' + esc(p.name) + '</span><button type="button" class="ceq-hgc__linkbtn" data-act="photo-remove" data-val="' + key + '">' + esc(this.tr('photo_remove')) + '</button></div>';
        return '<label class="ceq-hgc__upload"><b>' + esc(label) + '</b><span>' + esc(hint) + '</span><input type="file" accept="image/*" data-photo="' + key + '" class="ceq-hgc__file">' +
          (s.photoError[key] ? '<span class="ceq-hgc__err">' + esc(this.tr('photo_error')) + '</span>' : '') + '</label>';
      };
      const handover = this.handoverLines(sum, ops);
      const privacyUrl = this.dataset.privacyUrl;
      const privacyLink = privacyUrl ? '<a href="' + esc(privacyUrl) + '" target="_blank" rel="noopener">' + esc(this.tr('privacy_link')) + '</a>' : esc(this.tr('privacy_link'));
      let h = '<form class="ceq-hgc__card ceq-hgc__card--pad ceq-hgc__card--strong ceq-hgc__consult" novalidate data-hgc-form>' +
        '<div class="ceq-hgc__consult-head"><div class="ceq-hgc__card-title">' + esc(this.tr('consult_title')) + '</div><div class="ceq-hgc__note">' + esc(this.tr('consult_text')) + '</div></div>' +
        '<div class="ceq-hgc__consult-l"><label class="ceq-hgc__visually-hidden" for="hgc-f-question">' + esc(this.tr('consult_q')) + '</label>' +
        '<textarea class="ceq-hgc__in ceq-hgc__in--area" id="hgc-f-question" name="question" placeholder="' + esc(this.tr('consult_q')) + '" data-form="question">' + esc(f.question) + '</textarea>' +
        '<div class="ceq-hgc__g2">' + photo('room', this.tr('photo_room'), this.tr('photo_room_hint')) + photo('access', this.tr('photo_access'), this.tr('photo_access_hint')) + '</div>' +
        '<div class="ceq-hgc__field"><div class="ceq-hgc__lbl">' + esc(this.tr('channel')) + '</div>' + this.seg([{ id: 'mail', label: this.tr('chan_mail') }, { id: 'call', label: this.tr('chan_call') }], s.chan, 'chan', 'chan') + '</div>' +
        '<div class="ceq-hgc__g2">' + field('first', this.tr('first_name'), 'text', true, 'given-name') + field('last', this.tr('last_name'), 'text', true, 'family-name') + '</div>' +
        field('email', this.tr('email'), 'email', true, 'email') +
        field('phone', this.tr(s.chan === 'call' ? 'phone_call' : 'phone_opt'), 'tel', s.chan === 'call', 'tel') +
        '<div class="ceq-hgc__hp" aria-hidden="true"><label for="hgc-f-hp">' + esc(this.tr('honeypot')) + '</label><input id="hgc-f-hp" type="text" name="company_website" tabindex="-1" autocomplete="off" value="' + esc(f.hp) + '" data-form="hp"></div>' +
        '</div><div class="ceq-hgc__consult-r"><div class="ceq-hgc__handover"><b>' + esc(this.tr('handover_title')) + '</b>' + handover.map((l) => '<div>' + esc(l) + '</div>').join('') + '</div>' +
        '<div class="ceq-hgc__note ceq-hgc__fine">' + esc(this.tr('privacy')).replace('{link}', privacyLink) + '</div>' +
        '<button type="submit" class="ceq-hgc__btn ceq-hgc__btn--primary ceq-hgc__btn--block"' + (send.state === 'busy' ? ' disabled' : '') + '>' + esc(this.tr(send.state === 'busy' ? 'sending' : (send.state === 'fail' ? 'retry' : 'send'))) + '</button>';
      if (send.state === 'fail') h += '<div class="ceq-hgc__toast ceq-hgc__toast--err" role="alert"><div><b>' + esc(this.tr('fail_title')) + '</b><br>' + esc(this.tr('fail_text', { phone: this.phone })) + '</div></div>';
      if (send.state === 'test') {
        h += '<div class="ceq-hgc__test" role="status"><b>' + esc(this.tr('test_title')) + '</b><div class="ceq-hgc__note">' + esc(this.tr('test_text')) + '</div>' +
          '<details open><summary>' + esc(this.tr('test_prose')) + '</summary><pre>' + esc(send.prose) + '</pre></details>' +
          '<details><summary>' + esc(this.tr('test_json')) + '</summary><pre>' + esc(JSON.stringify(send.payload, null, 2)) + '</pre></details>' +
          (send.photos && send.photos.length ? '<details><summary>' + esc(this.tr('test_photos')) + '</summary><pre>' + esc(send.photos.join('\n')) + '</pre></details>' : '') + '</div>';
      }
      h += '</div></form>';
      return h;
    }
    handoverLines(sum, ops) {
      const s = this.s, room = s.room, facts = this.facts();
      const changed = Array.from(new Set(Object.keys(s.touched).map((k) => this.tr(CHANGE_LABEL[k] || k))));
      const h = facts.H === null ? this.tr('ho_h_unknown') : this.tr(room.hMeasured === 'after' ? 'ho_h_after' : 'ho_h_before', { h: facts.H });
      const extra = [room.use ? this.tr(room.use === 'drop' ? 'use_drop' : 'use_controlled') : null,
        room.neigh ? this.tr(room.neigh === 'darunter' ? 'neigh_below' : room.neigh === 'nebenan' ? 'neigh_next' : 'neigh_none') : null].filter(Boolean);
      return [
        this.tr('ho_training', { v: this.tr(s.training === 'B' ? 'goal_b' : 'goal_a') }),
        this.tr('ho_room', { l: this.fmt1(room.l / 100), w: this.fmt1(room.w / 100), h, shape: room.shape === 'angled' ? this.tr('ho_shape_angled', { a: this.fmt1(facts.area) }) : this.tr('ho_shape_rect') }),
        this.tr('ho_wall', { fix: this.tr('fix_' + room.fix) }) + (extra.length ? ' · ' + extra.join(' · ') : ''),
        this.tr('ho_setup', { n: sum.count, sum: chf(sum.total), changed: changed.length ? changed.join(', ') : this.tr('ho_nothing') }),
        ops.length ? this.plural('ho_open', ops.length) : this.tr('ho_open_none'),
        this.tr(s.montage ? 'ho_montage_yes' : 'ho_montage_no'),
        this.tr('ho_not_asked'),
      ];
    }

    /* ----- Ereignisse ----- */
    onKey(e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[role="radio"][data-act], [role="checkbox"][data-act]')) {
        e.preventDefault();
        e.target.click();
      }
    }
    onClick(e) {
      const a = e.target.closest('[data-act]');
      if (!a || !this.contains(a)) return;
      if (a.disabled || a.getAttribute('aria-disabled') === 'true') return;
      const act = a.dataset.act, key = a.dataset.key, val = a.dataset.val;
      const s = this.s;
      switch (act) {
        case 'goal': {
          const first = !s.training;
          if (s.training === val) { this.goStep(2); break; }
          s.replaced = null; this.afterChange();
          s.training = val; s.sel = this.defaults(val, s.room); s.touched = {}; s.cart = { state: 'idle' };
          if (first && !s.started) { s.started = true; track('hgc_start', { hgc_path: val === 'B' ? 'functional' : 'langhantel' }); }
          this.goStep(2);
          break;
        }
        case 'step': this.goStep(Number(val)); break;
        case 'next': if (s.step === 1 && !s.training) return; this.goStep(s.step + 1); break;
        case 'back': this.goStep(s.step - 1); break;
        case 'room': this.setRoom(key, val); break;
        case 'hmeasure':
          if (val === 'unknown') { this.setRoom('hUnknown', true); break; }
          s.room.hUnknown = false;
          this.setRoom('hMeasured', val);
          break;
        case 'sel': this.setSel({ [key]: val }); break;
        case 'extra': {
          const sel = this.sel(); const ex = EXTRAS.find((x) => x.id === val);
          const on = (sel.extras || []).includes(val);
          const list = (sel.extras || []).filter((x) => x !== val && (!ex || x !== ex.alt));
          if (!on) list.push(val);
          this.setSel({ extras: list });
          break;
        }
        case 'info': e.stopPropagation(); s.info = s.info === val ? null : val; this.render(); break;
        case 'storage': this.setSel({ storage: val === 'yes' }); break;
        case 'more': s.openZones[val] = !s.openZones[val]; this.render(); break;
        case 'cart': this.addToCart(); break;
        case 'consult': {
          if (!s.consultOpen) { track('hgc_consult_open', { hgc_path: this.gaPath() }); s.formOpenedAt = Date.now(); }
          s.consultOpen = true; this.render();
          const f = this.querySelector('[data-hgc-consult]');
          if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break;
        }
        case 'montage': this.afterChange(); s.montage = val === 'yes'; s.cart = { state: 'idle' }; this.render(); break;
        case 'chan': s.chan = val; delete s.errors.phone; this.render(); break;
        case 'photo-remove': s.photos[val] = null; this.render(); break;
        default: break;
      }
    }
    onInput(e) {
      const t = e.target;
      if (t.dataset.room) {
        const key = t.dataset.room, v = Number(t.value);
        if (key === 'h' && this.s.room.hUnknown) this.s.room.hUnknown = false;
        this.setRoom(key, v, true);
        this.updateRoomLive();
        return;
      }
      if (t.dataset.form) this.s.form[t.dataset.form] = t.value;
    }
    onChange(e) {
      const t = e.target;
      if (t.dataset.room) { this.render(); const el = this.querySelector('[data-room="' + t.dataset.room + '"]'); if (el) el.focus(); return; }
      if (t.dataset.photo) { const file = t.files && t.files[0]; if (file) this.takePhoto(t.dataset.photo, file); }
    }
    // Waehrend des Ziehens nur Anzeigen nachfuehren — den Slider selbst nicht neu rendern.
    updateRoomLive() {
      const room = this.s.room, facts = this.facts(), sum = this.sum();
      const set = (k, txt) => { const el = this.querySelector('[data-hgc-val="' + k + '"]'); if (el) el.textContent = txt; };
      set('l', room.l + ' cm'); set('w', room.w + ' cm'); set('h', room.hUnknown ? '?' : room.h + ' cm'); set('area', this.fmt1(facts.area) + ' m²');
      const side = this.querySelector('[data-hgc-side]');
      if (side) side.innerHTML = this.sideRoom(sum);
      const inline = this.querySelector('[data-hgc-plan-inline]');
      if (inline) inline.innerHTML = this.planHtml();
    }

    /* ----- Warenkorb ----- */
    // netzwerk = Request kam nicht durch (Firewall, offline, DNS, fehlende CORS-Freigabe) -- der Firewall-Fall.
    // timeout = keine Antwort in 30 s. http_<code> = n8n hat geantwortet, aber mit Fehler: ein Problem bei uns.
    failReason(err) {
      if (!this.webhook) return 'kein_webhook';
      if (err && err.name === 'AbortError') return 'timeout';
      const m = /^HTTP (\d{3})/.exec((err && err.message) || '');
      return m ? 'http_' + m[1] : 'netzwerk';
    }
    // Shopify liefert //host/cdn/...&width=480 (protokoll-relativ). Mailprogramme brauchen https, die Mail zeigt 56 px.
    mailImg(u) {
      if (!u) return null;
      const abs = u.indexOf('//') === 0 ? 'https:' + u : u;
      return /[?&]width=\d+/.test(abs) ? abs.replace(/([?&]width=)\d+/, '$1112') : abs + (abs.indexOf('?') >= 0 ? '&' : '?') + 'width=112';
    }
    gaPath() { return this.s.training === 'B' ? 'functional' : 'langhantel'; }
    // Gemeinsame Angaben der beiden Ziele: Weg, Artikelsumme, welche Bausteine gegenueber dem Vorschlag geaendert wurden.
    gaResult(sum) {
      const changed = Object.keys(this.s.touched).sort();
      return { hgc_path: this.gaPath(), value: Math.round(sum.total * 100) / 100, currency: 'CHF', hgc_changed: changed.length ? changed.join(',') : 'keine' };
    }
    cartSigOf(sum) { return JSON.stringify(sum.lines.filter((l) => !l.missing && l.avail).map((l) => l.items)); }
    async addToCart() {
      const s = this.s;
      const sum = this.sum();
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const items = []; let skipped = 0, added = 0, addedTotal = 0;
      sum.lines.forEach((l) => {
        if (l.missing || !l.avail) { skipped++; return; }
        added++; addedTotal += l.total;
        l.items.forEach(([sku, qty]) => items.push({ id: this.v(sku).id, quantity: qty, properties: { _Konfiguration: s.configId } }));
      });
      if (!items.length) { s.cart = { state: 'none' }; this.render(); return; }
      s.cart = { state: 'busy' }; this.render();
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      try {
        // Liegt ein frueherer Stand dieses Setups im Warenkorb, zuerst dessen Positionen entfernen -- sonst ist alles doppelt drin.
        if (s.cartConfigId) {
          const cur = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          const updates = {};
          (cur.items || []).forEach((it) => { if (it.properties && it.properties._Konfiguration === s.cartConfigId) updates[it.key] = 0; });
          if (Object.keys(updates).length) {
            const ru = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
            if (!ru.ok) throw new Error('HTTP ' + ru.status);
          }
        }
        const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const res = await r.json();
        if (!r.ok || res.status) throw new Error(res.description || res.message || ('HTTP ' + r.status));
        s.cart = { state: 'ok', added, addedTotal, skipped };
        s.cartAddedAt = new Date().toISOString(); s.cartPositions = added;
        s.cartSig = this.cartSigOf(sum); s.cartConfigId = s.configId;
        track('hgc_cart_add', Object.assign(this.gaResult(sum), { value: Math.round(addedTotal * 100) / 100 }));
        this.render();
        // Wie product-form.js: war der Warenkorb leer, traegt der Drawer noch is-empty und blendet die Positionen aus.
        if (drawer && res.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ceq-home-gym-configurator', cartData: res });
      } catch (err) {
        console.error('[ceq-hgc] Warenkorb fehlgeschlagen', err);
        s.cart = { state: 'fail', detail: err && err.message ? err.message : '' };
        this.render();
      }
    }

    /* ----- Fotos: auf max. 2000 px verkleinern, JPEG ----- */
    async takePhoto(key, file) {
      const s = this.s;
      delete s.photoError[key];
      try {
        if (!/^image\//.test(file.type) || file.size > PHOTO_INPUT_MAX) throw new Error('type/size');
        const blob = await this.shrink(file);
        s.photos[key] = { name: file.name, blob, size: blob.size, type: blob.type };
      } catch (e) {
        s.photos[key] = null; s.photoError[key] = true;
      }
      this.render();
    }
    async shrink(file) {
      let bmp;
      try { bmp = await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (e) { bmp = null; }
      if (!bmp) {
        if ((file.type === 'image/jpeg' || file.type === 'image/png') && file.size <= 8 * 1024 * 1024) return file;
        throw new Error('decode');
      }
      const sc = Math.min(1, PHOTO_MAX_PX / Math.max(bmp.width, bmp.height));
      const cv = document.createElement('canvas');
      cv.width = Math.round(bmp.width * sc); cv.height = Math.round(bmp.height * sc);
      cv.getContext('2d').drawImage(bmp, 0, 0, cv.width, cv.height);
      return await new Promise((res, rej) => cv.toBlob((b) => (b ? res(b) : rej(new Error('encode'))), 'image/jpeg', 0.85));
    }

    /* ----- Anfrage ----- */
    validate() {
      const f = this.s.form, e = {};
      if (!f.first.trim()) e.first = this.tr('err_first');
      if (!f.last.trim()) e.last = this.tr('err_last');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.trim())) e.email = this.tr('err_email');
      if (this.s.chan === 'call' && f.phone.replace(/[^\d+]/g, '').length < 7) e.phone = this.tr('err_phone');
      this.s.errors = e;
      return !Object.keys(e).length;
    }
    async submitConsult() {
      const s = this.s;
      if (s.send.state === 'busy') return;
      if (!this.validate()) {
        this.render();
        const first = this.querySelector('[aria-invalid="true"]');
        if (first) first.focus();
        return;
      }
      const sum = this.sum();
      const ops = this.openPoints(sum);
      const payload = this.buildPayload(sum, ops);
      const prose = this.salesSummary(sum, ops, payload);
      // Honeypot gefuellt oder in unter 2 s abgeschickt: still und ohne Versand "erfolgreich" -- der Bot lernt nichts.
      const fillMs = s.formOpenedAt ? Date.now() - s.formOpenedAt : 0;
      if (s.form.hp || fillMs < MIN_FILL_MS) { s.send = { state: 'ok' }; this.render(); return; }
      if (this.testMode) {
        const photos = ['room', 'access'].filter((k) => s.photos[k]).map((k) => k + ': ' + s.photos[k].name + ' (' + Math.round(s.photos[k].size / 1024) + ' KB, ' + s.photos[k].type + ')');
        s.send = { state: 'test', payload, prose, photos };
        this.render();
        return;
      }
      s.send = { state: 'busy' }; this.render();
      const fd = new FormData();
      fd.append('payload', JSON.stringify(payload));
      // n8n prueft beides nochmals selbst (wer den Webhook direkt anspricht, umgeht diesen Code).
      // Gesendet wird die im Browser gemessene Dauer: sie haengt nicht an einer falsch gehenden Geraeteuhr.
      fd.append('website', s.form.hp);
      fd.append('form_loaded_at', String(s.formOpenedAt));
      fd.append('form_fill_ms', String(fillMs));
      fd.append('summary', prose);
      if (s.photos.room) fd.append('photo_room', s.photos.room.blob, 'raum-' + s.configId.slice(0, 8) + '.jpg');
      if (s.photos.access) fd.append('photo_access', s.photos.access.blob, 'zufahrt-' + s.configId.slice(0, 8) + '.jpg');
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), SEND_TIMEOUT_MS);
      try {
        if (!this.webhook) throw new Error('kein Webhook konfiguriert');
        const r = await fetch(this.webhook, { method: 'POST', body: fd, signal: ctrl.signal });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        s.send = { state: 'ok' };
        // Nur bei echtem Versand: Testmodus, Honeypot und Timetrap zaehlen nicht.
        track('generate_lead', Object.assign(this.gaResult(sum), { lead_source: 'homegym_berater', hgc_montage: s.montage ? 'ja' : 'nein', hgc_soldout: sum.unavailable }));
      } catch (err) {
        console.error('[ceq-hgc] Anfrage fehlgeschlagen', err);
        s.send = { state: 'fail' };
        // Macht messbar, was bisher keine Spur hinterliess: Firmen-Firewalls blocken *.n8n.cloud, der Request
        // kommt nie an (crossequip-knowledge/formular-botschutz.md). Untergrenze -- wer auch GA blockt, fehlt hier.
        track('hgc_consult_fail', { hgc_path: this.gaPath(), hgc_fail_reason: this.failReason(err) });
      } finally {
        clearTimeout(timer);
      }
      this.render();
    }

    // Maschinenlesbarer Projektstand. Sprachneutrale Codes, Texte nur als Beigabe.
    buildPayload(sum, ops) {
      const s = this.s, room = s.room, facts = this.facts(), sel = this.sel(), f = s.form;
      const st = this.storageCalc();
      const fp = this.floorPick(sel);
      const ROOM_KEYS = { l: 'length_cm', w: 'width_cm', h: 'height_cm' };
      return {
        schema: PAYLOAD_SCHEMA,
        config_id: s.configId,
        previous_config_id: s.prevConfigId,
        tool_version: TOOL_VERSION,
        submitted_at: new Date().toISOString(),
        language: this.lang,
        page_url: window.location.origin + window.location.pathname,
        source: this.source,
        contact: { first_name: f.first.trim(), last_name: f.last.trim(), email: f.email.trim(), phone: f.phone.trim() || null, reply_channel: s.chan, question: f.question.trim() || null, montage_wanted: !!s.montage },
        training: { path: s.training, label: this.tr(s.training === 'B' ? 'goal_b' : 'goal_a') },
        room: {
          customer_input: true,
          length_cm: room.l, width_cm: room.w,
          height_cm: facts.H, height_measured: facts.H === null ? 'unknown' : (room.hMeasured === 'after' ? 'finished_floor' : 'before_floor'),
          usable_height_cm: sum.usable,
          shape: room.shape === 'angled' ? 'irregular' : 'rectangular',
          training_area_m2: Math.round(facts.area * 100) / 100,
          fixing: room.fix,   // wall | floor | none | unknown
          weights: room.use === 'drop' ? 'dropped' : (room.use ? 'controlled' : null),
          neighbours: room.neigh === 'darunter' ? 'flat_below' : room.neigh === 'nebenan' ? 'next_door' : (room.neigh ? 'none' : null),
          // Regler, die nie bewegt wurden: der Wert ist der Startwert des Tools, keine Kundenangabe.
          untouched_defaults: Object.keys(ROOM_KEYS).filter((k) => !s.roomTouched[k] && !(k === 'h' && (s.roomTouched.hUnknown || room.hUnknown))).map((k) => ROOM_KEYS[k]),
        },
        selection: Object.assign({}, sel, { floor: fp.floor ? fp.floor.id : 'none', colour: fp.colour }),   // der effektiv bestellte Boden
        proposal_defaults: this.defaults(s.training, room),
        changed_vs_proposal: Object.keys(s.touched),
        items: sum.lines.map((l) => ({
          block: l.block, option: l.option, name: l.name,
          // Fuer die Kundenmail (n8n «Kundenmail bauen»): Detailzeile wie im Tool und ein absolutes Produktbild.
          sub: l.sub || '', image_url: this.mailImg(l.img),
          articles: l.items.map(([sku, qty]) => { const v = this.v(sku); return { sku, qty, variant_id: v ? v.id : null, unit_price_chf: v ? v.price / 100 : null, available: v ? v.available : null }; }),
          total_chf: l.total, available: l.avail, without_price: l.missing,
        })),
        item_total_chf: Math.round(sum.total * 100) / 100,
        items_unavailable: sum.unavailable,
        items_without_price: sum.missing,
        storage: st.any ? { accepted: !!sel.storage, shelves_db_short: st.db, shelves_kb_short: st.kb, levels: st.n, uprights: st.big ? null : st.up, price_chf: st.big ? null : st.price, needs_second_rack: !!st.big } : null,
        open_points: ops.map((o) => ({ code: o.key, text: o.text })),
        not_asked: ['budget', 'date', 'existing_equipment', 'number_of_users'],
        photos: { room: !!s.photos.room, access: !!s.photos.access },
        cart: { added_at: s.cartAddedAt, positions: s.cartPositions },
      };
    }

    // Uebergabetext fuer den Verkauf — bewusst immer Deutsch (siehe Kopfkommentar).
    // Trennt, was der Kunde angegeben, was das Tool angenommen und was noch niemand geprueft hat.
    salesSummary(sum, ops, p) {
      const s = this.s, room = s.room, facts = this.facts(), sel = this.sel();
      const n1 = (x) => (Math.round(x * 10) / 10).toString().replace('.', ',');
      const L = [];
      const now = new Date();
      const stamp = now.toLocaleDateString('de-CH') + ' ' + now.toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' });
      L.push('HOMEGYM-BERATER · Anfrage ' + s.configId.slice(0, 8));
      L.push('Eingang ' + stamp + ' · Sprache ' + this.lang.toUpperCase() + ' · Antwort gewünscht: ' + (s.chan === 'call' ? 'Rückruf' : 'per E-Mail'));
      L.push('');
      L.push('KONTAKT');
      L.push(p.contact.first_name + ' ' + p.contact.last_name + ' · ' + p.contact.email + (p.contact.phone ? ' · ' + p.contact.phone : ''));
      L.push('Frage: ' + (p.contact.question ? '«' + p.contact.question + '»' : '–'));
      L.push('Montage gewünscht: ' + (s.montage ? 'JA — separat offerieren' : 'nein'));
      L.push('');
      L.push('TRAINING');
      L.push((s.training === 'B' ? 'B · Vielseitiges Functionaltraining' : 'A · Krafttraining mit Langhantel'));
      L.push('');
      L.push('RAUM — Kundenangaben, nicht von uns gemessen');
      L.push(n1(room.l / 100) + ' × ' + n1(room.w / 100) + ' m, ' + (room.shape === 'angled' ? 'verwinkelt, genutzte Trainingsfläche ' + n1(facts.area) + ' m²' : 'rechteckig, ' + n1(facts.area) + ' m²'));
      if (facts.H === null) L.push('Höhe: unbekannt');
      else L.push('Höhe: ' + facts.H + ' cm ' + (room.hMeasured === 'after' ? 'ab fertigem Boden' : 'gemessen vor dem Boden') + ' → nutzbar ' + n1(sum.usable) + ' cm');
      L.push('Befestigung: ' + ({ wall: 'geeignete Wand, Montage erlaubt (Beton/massives Mauerwerk)', floor: 'keine Wandmontage, Bodenverankerung möglich', none: 'keine Fixierung, soll verschiebbar bleiben', unknown: 'weiss noch nicht' })[room.fix]);
      L.push('Gewichte: ' + (room.use === 'drop' ? 'auch fallen lassen' : (room.use ? 'kontrolliert ablegen' : 'nicht beantwortet')) + ' · Wer hört mit: ' + (({ darunter: 'Wohnung darunter', nebenan: 'Familie nebenan', keine: 'niemand' })[room.neigh] || 'nicht beantwortet'));
      const untouched = [['l', 'Länge ' + room.l + ' cm'], ['w', 'Breite ' + room.w + ' cm'], ['h', 'Höhe ' + room.h + ' cm']].filter(([k]) => !s.roomTouched[k] && !(k === 'h' && room.hUnknown)).map((x) => x[1]);
      if (untouched.length) L.push('ACHTUNG — Regler nie bewegt, das ist der Startwert des Tools und KEINE Kundenangabe: ' + untouched.join(', '));
      if (s.prevConfigId) L.push('Ersetzt die frühere Anfrage ' + s.prevConfigId.slice(0, 8) + ' (nach dem Senden geändert).');
      L.push('');
      L.push('SETUP — ' + sum.count + ' Positionen, Artikelsumme CHF ' + chf(sum.total) + ' (Shop-Preise vom ' + now.toLocaleDateString('de-CH') + ', ohne Versand)');
      sum.lines.forEach((l) => {
        const arts = l.items.map(([sku, qty]) => qty + '× ' + sku).join(', ');
        L.push('- ' + l.name + (arts ? ' [' + arts + ']' : '') + ' — ' + (l.missing ? 'ohne Shop-Preis' : 'CHF ' + chf(l.total)) + (!l.missing && !l.avail ? ' — NICHT AB LAGER' : ''));
      });
      const st = this.storageCalc();
      if (st.any && !sel.storage) L.push('- Storage vorgeschlagen, nicht übernommen: ' + st.n + ' Ebenen (' + st.db + '× DB, ' + st.kb + '× KB kurz)');
      if (st.any && st.big && sel.storage) L.push('  Storage: mehr als vier Ebenen — Aufbau mit zwei Regalen planen, nicht bepreist');
      if (s.cartAddedAt) L.push('In den Warenkorb gelegt: ' + s.cartPositions + ' Positionen (Warenkorb-Eigenschaft _Konfiguration = ' + s.configId + ')');
      L.push('');
      const changed = Object.keys(s.touched);
      L.push('GEGENÜBER DEM VORSCHLAG GEÄNDERT');
      L.push(changed.length ? changed.map((k) => ({ floor: 'Boden', colour: 'Bodenfarbe', rack: 'Rack', bar: 'Langhantel', plates: 'Scheiben', line: 'Scheibenlinie', bench: 'Bank', hex: 'Kurzhanteln', kbLine: 'KB-Linie', kb: 'Kettlebells', pullup: 'Klimmzüge', extras: 'Extras', storage: 'Storage' })[k] || k).join(', ') : 'nichts');
      L.push('');
      L.push('VOM TOOL ANGENOMMEN — nicht vom Kunden bestätigt');
      if (sel.floor !== 'none') L.push('- Bodenmenge: ' + n1(facts.area) + ' m² × ' + (room.shape === 'angled' ? '1,10' : '1,05') + ', aufgerundet auf ' + sum.floorQty + ' Platten à 1 m²');
      if (s.training === 'A') {
        if (sel.rack === 'sqst') L.push('- Squat-Stand-Höhe ' + sqstVariant(sum.usable).h + ' cm aus der nutzbaren Höhe abgeleitet');
        if (!s.touched.rack && sel.rack !== 'none') L.push('- Rack aus Befestigung, Höhe und Lagerbestand vorgeschlagen');
        if (!s.touched.bar && sel.bar !== 'none') L.push('- Langhantel aus längster Raumseite (' + (facts.maxSide < 400 ? 'unter 4 m → BB-H15' : 'ab 4 m → BB-20') + ')');
        if (!s.touched.bench && sel.bench === 'flat') L.push('- Flat Bench vorausgewählt (Arbeitsannahme)');
        if (sel.plates !== 'none') L.push('- Change Plates HG-CP-SET-S immer bei den Scheiben');
      }
      if (st.any && sel.storage && !st.big) L.push('- Storage: 2 Pfosten ' + (st.up === STORAGE.upS ? 'tief' : 'hoch') + ' + ' + st.n + ' kurze Ablagen, Breiten aus dem storage-rechner');
      L.push('');
      L.push('OFFEN / ZU PRÜFEN');
      const opDe = { op_h_unknown: 'Raumhöhe unbekannt: Passform Rack und Bewegungsraum nicht bestätigt',
        op_h_low: 'Nutzbare Höhe ' + n1(sum.usable || 0) + ' cm: Übungen über dem Rack und Montage prüfen',
        op_fix_unknown: 'Befestigung offen: freistehend geplant, Wand/Boden klären',
        op_wall: 'Wand nicht bestätigt: Wandmontage hängt von Material und Bohrerlaubnis ab',
        op_cpr100: 'CPR-100: Bodenverankerung empfohlen, Bodenaufbau und Fussbodenheizung klären',
        op_apex: 'A-PEX: Ausführung und Höhe bestätigen', op_rings: 'Ringe: Aufhängung nicht definiert',
        op_noise: 'Lärm: Abwerfen mit Nachbarn, Dropping Mats / Test-Aufbau offen',
        op_storage_big: 'Storage: mehr als vier Ebenen, zwei Regale planen',
        op_room_default: 'Raummasse nie verstellt (Startwert ' + n1(room.l / 100) + ' × ' + n1(room.w / 100) + ' m): Bodenmenge und Stangenlänge nachfragen',
        unavailable: sum.unavailable + ' Position(en) nicht ab Lager: Liefertermin nennen',
        op_missing: 'Position(en) ohne Shop-Preis' };
      L.push(ops.length ? ops.map((o) => '- ' + (opDe[o.key] || o.text)).join('\n') : '- nichts');
      L.push('');
      L.push('NICHT GEFRAGT: Budget, Termin, vorhandenes Equipment, Personenzahl.');
      L.push('FOTOS: Raum ' + (s.photos.room ? 'ja' : 'nein') + ' · Zufahrt ' + (s.photos.access ? 'ja' : 'nein'));
      const src = Object.keys(this.source).map((k) => k + '=' + this.source[k]).join(', ');
      L.push('HERKUNFT: ' + (src || 'unbekannt'));
      return L.join('\n');
    }
  }

  customElements.define('ceq-home-gym-configurator', HomeGymConfigurator);
  // Formular-Submit auf document, damit Enter im Feld absendet und die Validierung greift.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('[data-hgc-form]');
    if (!form) return;
    e.preventDefault();
    const host = form.closest('ceq-home-gym-configurator');
    if (host) host.submitConsult();
  });
})();
